import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Modal,
  Dropdown,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  openDialer,
  setPhoneNumber,
} from "../../../core/data/redux/slices/FloatingDialerSlice";
import { contactStatus } from "../../../core/common/selectoption/selectoption";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useDropzone } from "react-dropzone";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Table from "../../../core/common/dataTable/index";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { utils, writeFile } from "xlsx";
import {
  accountType,
  ascendingandDecending,
  companyName,
  documentType,
  duration,
  languageOptions,
  LocaleData,
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  callStatus,
  socialMedia,
  taskType,
  meetingType,
  status,
  statusList,
  tagInputValues,
  owner as companyEmployee,
  all_tags,
} from "../../../core/common/selectoption/selectoption";
// import DatePicker from "react-datepicker";
import DefaultEditor from "react-simple-wysiwyg";
import { TagsInput } from "react-tag-input-component";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CiEdit, CiPlay1 } from "react-icons/ci";
import { FcApproval, FcUpload } from "react-icons/fc";
import {
  FaCalendarAlt,
  FaCloudDownloadAlt,
  FaPhoneSlash,
  FaRegBell,
  FaTasks,
} from "react-icons/fa";
import { SlPeople } from "react-icons/sl";
import { IoMdAttach, IoMdDoneAll } from "react-icons/io";
import {
  Card,
  DatePicker,
  Space,
  Spin,
  Statistic,
  TimePicker,
  Typography,
} from "antd";
import {
  MdAttachMoney,
  MdDownloadDone,
  MdOutlineRemoveDone,
  MdPhoneInTalk,
  MdDoubleArrow,
} from "react-icons/md";
import { RiVideoOnLine } from "react-icons/ri";
import {
  IoAlertCircle,
  IoCall,
  IoCallOutline,
  IoLocationSharp,
  IoTicketOutline,
} from "react-icons/io5";
import { leadsData } from "../../../core/data/json/leads";
import CustomerOffcanvas from "../../../core/common/offCanvas/customer/CustomerOffcanvas";
import DeleteModal from "../../../core/common/modals/DeleteModal";
import {
  getSingleContactOrLead,
  deleteContactOrLead,
  toggleContactFavorite,
  updateContactTags,
  getUserTags,
  addEditContactOrLead,
  getContactPipeline,
} from "../../../core/api/contactApi";
import {
  addOrUpdateTask,
  deleteTask,
  getTasksForContact,
} from "../../../core/api/taskApi";
import {
  addOrUpdateMeeting,
  deleteMeeting,
  getMeetingsForContact,
} from "../../../core/api/meetingApi";
import {
  fetchContactDetailsWithCache,
  fetchTasksWithCache,
  fetchMeetingsWithCache,
  clearContactDetailsCache,
  clearTasksCache,
  clearMeetingsCache,
  updateContactInCache,
  updateTaskInCache,
  deleteTaskFromCache,
} from "../../../core/data/redux/slices/ContactSlice";
import { clearEventsCache } from "../../../core/data/redux/slices/EventSlice";

import "./index.css";
import {
  clearCallHistoryNumber,
  fetchCallHistoryNumber,
} from "../../../core/data/redux/slices/CallHistoryNumberSlice";
import DateRangePicker from "react-bootstrap-daterangepicker";
import api from "../../../core/axios/axiosInstance";
import EmailTemplateModal from "../../common/EmailTemplateModal";
import WhatsappTemplateModal from "../../common/WhatsappTemplateModal";
import { setSelectedContact } from "../../../core/data/redux/slices/SelectedContactSlice";
import AvatarInitialStyles from "../../../core/common/nameInitialStyles/AvatarInitialStyles";
import { addTag, fetchTags } from "../../../core/data/redux/slices/TagSlice";
import { FiCopy } from "react-icons/fi";
import { LoadingOutlined } from "@ant-design/icons";
const allNotes = [
  {
    photo: "assets/img/profiles/avatar-19.jpg",
    name: "California media",
    dateCreated: "15 Sep 2023, 12:10 pm",
    lastModified: "15 Sep 2023, 12:10 pm",
    isContacted: true,
    noteHeading: "Important announcement",
    noteText:
      "A project review evaluates the success of an initiative and identifies areas for improvement. It can also evaluate a current project to determine whether it's on the right track. Or, it can determine the success of a completed project.",
    uploadedFiles: [
      {
        fileName: "Project Specs.xls",
        fileSize: "365 kb",
        fileLogo: "assets/img/media/media-35.jpg",
      },
      {
        fileName: "Project.pdf",
        fileSize: "4 MB",
        fileLogo: "assets/img/media/media-35.jpg",
      },
    ],
  },
  {
    photo: "assets/img/profiles/avatar-19.jpg",
    name: "California media",
    dateCreated: "15 Sep 2023, 12:12 pm",
    lastModified: "15 Sep 2023, 12:10 pm",
    isContacted: false,
    noteHeading: "Not Important announcement",
    noteText:
      "A project review evaluates the success of an initiative and identifies areas for improvement. It can also evaluate a current project to determine whether it's on the right track. Or, it can determine the success of a completed project.",
    noteComments: [
      {
        commentText:
          "The best way to get a project done faster is to start sooner. A goal without a timeline is just a dream.The goal you set must be challenging. At the same time, it should be realistic and attainable, not impossible to reach.",
        commentedBy: "Aeron",
        commentTime: "17 Sep 2023, 12:10 pm",
      },
      {
        commentText:
          "The best way to get a project done faster is to start sooner. A goal without a timeline is just a dream.The goal you set must be challenging. At the same time, it should be realistic and attainable, not impossible to reach.",
        commentedBy: "Aeron",
        commentTime: "17 Sep 2023, 12:10 pm",
      },
    ],
    uploadedFiles: [
      {
        fileName: "Project Specs.xls",
        fileSize: "365 kb",
        fileLogo: "assets/img/media/media-35.jpg",
      },
      {
        fileName: "Project.pdf",
        fileSize: "4 MB",
        fileLogo: "assets/img/media/media-35.jpg",
      },
    ],
  },
];
const allTasks = [
  {
    name: "California Media",
    photo: "assets/img/profiles/avatar-19.jpg",
    title: "Important Meeting",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Fugiat sed culpa rem odio natus inventore eaque beatae voluptas, delectus alias omnis, totam eveniet dolore quia!",
    taskType: "Follow Up",
    isCompleted: "false",
    dateCreated: "16 Sep 2023, 12:10 pm",
    dueDate: "15 Sep 2024",
    dueTime: "11.40 pm",
  },
  {
    name: "California Media",
    photo: "assets/img/profiles/avatar-19.jpg",
    title: "Important Meeting",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Fugiat sed culpa rem odio natus inventore eaque beatae voluptas, delectus alias omnis, totam eveniet dolore quia!",
    taskType: "Reminder",
    isCompleted: "false",
    dateCreated: "17 Sep 2023, 12:10 pm",
    dueDate: "15 Oct 2024",
    dueTime: "11.40 pm",
  },
  {
    name: "California Media",
    photo: "assets/img/profiles/avatar-19.jpg",
    title: "Important Meeting",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Fugiat sed culpa rem odio natus inventore eaque beatae voluptas, delectus alias omnis, totam eveniet dolore quia!",
    taskType: "Reminder",
    isCompleted: "true",
    dateCreated: "18 Sep 2023, 12:10 pm",
    dueDate: "15 Oct 2024",
    dueTime: "11.40 pm",
  },
];

const ContactDetails = () => {
  const route = all_routes;
  const { Title, Text } = Typography;
  const callStatus = [
    { value: "noAnswered", label: "Not Answered" },
    { value: "answered", label: "Answered" },
    { value: "missedCall", label: "Missed" },
    { value: "cancelled", label: "Cancelled" },
    { value: "invalid", label: "Invalid" },
  ];
  const callDirection = [
    { value: "inbound", label: "Inbound" },
    { value: "outbound", label: "Outbound" },
  ];
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const closeMeetingRef = useRef(null)
  const last7Start = new Date(today);
  last7Start.setDate(today.getDate() - 7);

  const last30Start = new Date(today);
  last30Start.setDate(today.getDate() - 30);

  const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const thisMonthEnd = new Date(
    now.getFullYear(),
    now.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  );

  const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastMonthEnd = new Date(
    now.getFullYear(),
    now.getMonth(),
    0,
    23,
    59,
    59,
    999
  );

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const initialCustomerInfo =
    location.state?.record || location.state?.customer || {};



  const [customerInfo, setCustomerInfo] = useState(initialCustomerInfo);
  const data = leadsData;
  const activityToggle = useSelector((state) => state?.activityTogglePopup);
  const activityToggleTwo = useSelector(
    (state) => state?.activityTogglePopupTwo
  );
  const [openModal, setOpenModal] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const [contactedToday, setContactedToday] = useState(true);
  const [isFavLoading, setIsFavLoading] = useState(false);
  const [copiedId, setCopiedId] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [activeRowKey, setActiveRowKey] = useState(null);
  const [isEditor2, setIsEditor2] = useState(false);
  const [sortOrder, setSortOrder] = useState("Descending");
  const [selectedTask, setSelectedTask] = useState(null);
  const [sortOrderIncompleteTask, setSortOrderIncompleteTask] =
    useState("Descending");
  const [sortOrderCompletedTask, setSortOrderCompletedTask] =
    useState("Descending");
  const [hoveredTaskCompletedIndex, setHoveredTaskCompletedIndex] =
    useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [searchEmployeeInFilter, setSearchEmployeeInFilter] = useState("");
  const [selectedCallDirection, setSelectedCallDirection] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [selectedNote, setSelectedNote] = useState(null);
  const [selectedMeetingType, setSelectedMeetingType] = useState(null);
  const [selectedCallStatus, setSelectedCallStatus] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isRefreshingCalls, setIsRefreshingCalls] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [hoveredMeetingIndex, setHoveredMeetingIndex] = useState(null);
  const [formattedPhones, setFormattedPhones] = useState([]);
  const [indexToDelete, setIndexToDelete] = useState(null);
  const [stars, setStars] = useState({});
  const [hoveredTaskIndex, setHoveredTaskIndex] = useState(null);
  const [activeEditorIndex, setActiveEditorIndex] = useState(null);
  const [hoveredNoteIndex, setHoveredNoteIndex] = useState(null);
  const [isEditor3, setIsEditor3] = useState(false);
  const [owner, setOwner] = useState(["Collab"]);
  const [selectedDate1, setSelectedDate1] = useState(new Date());
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [deleteModalText, setDeleteModalText] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [isLoadingTags, setIsLoadingTags] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedPhone, setSelectedPhone] = useState("");
  const [allTags, setAllTags] = useState([]);
  const [previousTags, setPreviousTags] = useState([]);
  const [isMeetingLoading, setIsMeetingLoading] = useState(false);
  const [newTags, setNewTags] = useState([]);
  const [removedTags, setRemovedTags] = useState([]);
  const { tags } = useSelector((state) => state.tags);
  // Pipeline state
  const [pipeline, setPipeline] = useState([]);
  const [loadingPipeline, setLoadingPipeline] = useState(false);
  const callHistoryNumberState =
    useSelector((state) => state.callHistoryNumber) || {};
  const callLogs = callHistoryNumberState.data;
  const callLogsSummary = callHistoryNumberState.summary;
  // Task state
  const [tasks, setTasks] = useState([]);
  const [taskFormData, setTaskFormData] = useState({
    taskDescription: "",
    taskDueDate: null,
    taskDueTime: "",
    taskIsCompleted: false,
  });
  const [startDate, setStartDate] = useState(
    new Date(
      last7Start.getFullYear(),
      last7Start.getMonth(),
      last7Start.getDate(),
      0,
      0,
      0,
      0
    ).toISOString()
  );
  const [endDate, setEndDate] = useState(
    new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      23,
      59,
      59,
      999
    ).toISOString()
  );
  const userProfile = useSelector((state) => state.profile);
  const contactStatusOptions =
    userProfile.contactStatuses && userProfile.contactStatuses.length > 0
      ? userProfile.contactStatuses
      : contactStatus;

  const STATUS_PALETTE = [
    "#3C2371","#1890ff","#52c41a","#faad14","#f5222d",
    "#722ed1","#13c2c2","#eb2f96","#fa8c16","#a0d911",
  ];
  const hashStr = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
    return Math.abs(h);
  };
  const getStatusStyle = (statusValue) => {
    const matched = contactStatusOptions.find((s) => s.value === statusValue);
    const hex = matched?.color || STATUS_PALETTE[hashStr(statusValue || "") % STATUS_PALETTE.length];
    return {
      color: hex,
      backgroundColor: hex + "22",
      border: `1px solid ${hex}55`,
    };
  };
  // useEffect(() => {
  //   dispatch(
  //     fetchCallHistoryNumber({
  //       page: 1,
  //       page_size: 10,
  //       search: "",
  //       status: "",
  //       callType: "",
  //       phoneNumbers:customerInfo.allPhones
  //       // startDate,
  //       // endDate,
  //     })
  //   );
  // }, []);

  useEffect(() => {
    if (!customerInfo?.allPhones) return;
    dispatch(clearCallHistoryNumber());
    const _formattedPhones = customerInfo.allPhones
      .filter((p) => typeof p === "string" && p.trim() !== "")
      .map((p) => {
        const phoneNumber = parsePhoneNumberFromString(p.trim(), "AE");
        if (!phoneNumber) return null;

        return {
          number: phoneNumber.nationalNumber,
          countryCode: phoneNumber.countryCallingCode,
        };
      })
      .filter(Boolean);

    // Save in state
    setFormattedPhones(_formattedPhones);

    // Dispatch using the newly formatted phones
    dispatch(
      fetchCallHistoryNumber({
        page: 1,
        page_size: 10,
        search: "",
        status: selectedCallStatus,
        callType: selectedCallDirection,
        phonenumbers: _formattedPhones,
        startDate,
        endDate,
      })
    );
  }, [
    customerInfo,
    searchQuery,
    selectedCallStatus,
    startDate,
    endDate,
    selectedCallDirection,
  ]);

  // useEffect(() => {
  //   if (!customerInfo?.allPhones) return;

  //   const formattedPhones = customerInfo.allPhones
  //     .filter((p) => typeof p === "string" && p.trim() !== "")  // ensure valid strings
  //     .map((p) => {
  //       const phoneNumber = parsePhoneNumberFromString(p.trim(), "AE");
  //       if (!phoneNumber) return null;

  //       return {
  //         number: phoneNumber.nationalNumber,
  //         countryCode: phoneNumber.countryCallingCode,
  //       };
  //     })
  //     .filter(Boolean);

  //   dispatch(
  //     fetchCallHistoryNumber({
  //       page: 1,
  //       page_size: 10,
  //       search: "",
  //       status: selectedCallStatus,
  //       callType: selectedCallDirection,
  //       phonenumbers: formattedPhones,
  //       startDate,
  //       endDate
  //     })
  //   );
  // }, [customerInfo, searchQuery, selectedCallStatus, startDate, endDate, selectedCallDirection]);


  useEffect(() => {

    if (customerInfo?._originalData?.tags) {
      const formattedTags = customerInfo?._originalData?.tags.map((tag) => ({
        value: tag.tag,
        label: `${tag.emoji} ${tag.tag}`,
        emoji: tag.emoji,
      }));
      setSelectedTags(formattedTags);
      setPreviousTags(formattedTags);
    }
  }, [customerInfo]);


  const formatCallDate = (value) => {
    if (!value) return "";
    // const dubaiTime = dayjs.tz(value, "Asia/Dubai");
    // return dubaiTime.tz(dayjs.tz.guess()).format("DD MMM YYYY, h:mma");
    return dayjs(value).format("DD MMM YYYY, h:mma");
  };

  const formatCallDuration = (value) => {
    if (!value) return "";

    const totalSeconds = Number(value);
    if (isNaN(totalSeconds)) return "";

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return hours > 0
      ? `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`
      : `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  //     useEffect(() => {
  //   if (!customerInfo?.allPhones) return;

  //   const formattedPhones = customerInfo.allPhones
  //     .map((p) => {
  //       const phoneNumber = parsePhoneNumberFromString(p, 'AE');
  //       if (!phoneNumber) return null;

  //       return {
  //         number: phoneNumber.nationalNumber,
  //         countryCode: phoneNumber.countryCallingCode
  //       };
  //     })
  //     .filter(Boolean);

  //   dispatch(
  //     fetchCallHistoryNumber({
  //       page: 1,
  //       page_size: 10,
  //       search: "",
  //       status: "",
  //       callType: "",
  //       phoneNumbers: formattedPhones
  //     })
  //   );
  // }, [customerInfo]);
  const [taskSortOrder, setTaskSortOrder] = useState("descending");
  const [loadingTasksFetch, setLoadingTasksFetch] = useState(false);
  const [loadingTasksSubmit, setLoadingTasksSubmit] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [taskToDelete, setTaskToDelete] = useState(null);

  // Activities state
  const [activities, setActivities] = useState([]);
  const [activitySortOrder, setActivitySortOrder] = useState("descending");
  const [activityFilter, setActivityFilter] = useState("all");

  // Meetings state
  const [meetings, setMeetings] = useState([]);
  const [meetingFormData, setMeetingFormData] = useState({
    meetingTitle: "",
    meetingDescription: "",
    meetingStartDate: null,
    meetingStartTime: "",
    meetingType: "offline",
    meetingLocation: "",
    meetingProvider: null,
  });
  const [meetingSortOrder, setMeetingSortOrder] = useState("descending");
  const [loadingMeetings, setLoadingMeetings] = useState(false);
  const [meetingToEdit, setMeetingToEdit] = useState(null);
  const [meetingToDelete, setMeetingToDelete] = useState(null);

  const [columnVisibility, setColumnVisibility] = useState({
    "": true,
    "Call Id": true,
    "Agent Name": true,
    "Call Type": true,
    "Call Date": true,
    Direction: true,
    "Call Duration": true,
    "Call Status": true,
    Recording: true,
    Charges: true,
    Extension: true,
  });
  const fetchActivities = async () => {
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      if (!contact_id) return;

      const response = await api.get("/getAllContactsOrLeads/activities", {
        params: {
          contact_id,
          category: "contact",
        },
      });

      if (response.data.status === "success") {
        setActivities(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching activities:", error);
    }
  };


  const handleCopy = async (meeting) => {
    await navigator.clipboard.writeText(meeting.meetingLink);
    setCopiedId(meeting.id);

    setTimeout(() => {
      setCopiedId(null);
    }, 2000);
  };
  // Fetch contact details on component mount
  // useEffect(() => {
  //   const fetchContactDetails = async () => {
  //     if (
  //       customerInfo._originalData?.contact_id ||
  //       customerInfo.id ||
  //       customerInfo.key
  //     ) {
  //       try {
  //         const contact_id =
  //           customerInfo._originalData?.contact_id ||
  //           customerInfo.id ||
  //           customerInfo.key;

  //         // Fetch from Redux cache or API
  //         const result = await dispatch(
  //           fetchContactDetailsWithCache(contact_id)
  //         );
  //         const response = result.payload;

  //         if (response && response.data) {
  //           const contactData = response.data;
  //           // Transform the data to match the expected format
  //           const transformedData = {
  //             ...customerInfo,
  //             _originalData: contactData,
  //             customer_name: `${contactData.firstname || ""} ${contactData.lastname || ""
  //               }`.trim(),
  //             email: contactData.emailAddresses?.[0] || "",
  //             allEmails: contactData.emailAddresses || [],
  //             phone: contactData.phoneNumbers?.[0]
  //               ? `${contactData.phoneNumbers[0].countryCode || ""} ${contactData.phoneNumbers[0].number || ""
  //                 }`.trim()
  //               : "",
  //             allPhones:
  //               contactData.phoneNumbers?.map((p) =>
  //                 `${p.countryCode || ""} ${p.number || ""}`.trim()
  //               ) || [],
  //             customer_company: contactData.company || "",
  //             customer_occupation: contactData.designation || "",
  //             customer_image: contactData.contactImageURL || "",
  //             isFavourite: contactData.isFavourite || false,
  //             status: contactData.status,
  //             website: contactData.website || "",
  //             notes: contactData.notes || "",
  //             id: contactData.contact_id || contactData._id,
  //             key: contactData.contact_id || contactData._id,
  //           };

  //           dispatch(setSelectedContact(transformedData));
  //           setCustomerInfo(transformedData);

  //           // Set tags
  //           if (contactData.tags && contactData.tags.length > 0) {
  //             setSelectedTags(
  //               contactData.tags.map((tag) => ({
  //                 value: tag.tag_id,
  //                 label: tag.tag,
  //                 emoji: tag.emoji,
  //               }))
  //             );
  //           }

  //           // Set default selected email and phone
  //           setSelectedEmail(transformedData.email);
  //           setSelectedPhone(transformedData.phone);

  //           // Set activities from contact data
  //           if (contactData.activities) {
  //             setActivities(contactData.activities);
  //           }

  //           // Fetch pipeline data
  //           fetchPipelineData(contact_id);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching contact details:", error);
  //         dispatch(
  //           showToast({
  //             message: "Failed to fetch contact details",
  //             variant: "danger",
  //           })
  //         );
  //       }
  //     }
  //   };

  //   fetchContactDetails();
  // }, []);




  useEffect(() => {
    const tagsArrayOfObject = tags.map((tag) => {
      return {
        value: tag.tag,
        label: `${tag.emoji}${" "}${tag.tag}`,
        emoji: tag.emoji,
      };
    });
    setAllTags(tagsArrayOfObject);
  }, [tags]);


  useEffect(() => {
    const fetchContactDetails = async () => {

      if (
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key
      ) {
        try {
          const contact_id =
            customerInfo._originalData?.contact_id ||
            customerInfo.id ||
            customerInfo.key;


          // Fetch from Redux cache or API
          const result = await dispatch(
            fetchContactDetailsWithCache(contact_id)
          );

          const response = result.payload;

          if (response && response.data) {
            const contactData = response.data;

            // Transform the data to match the expected format
            const transformedData = {
              ...customerInfo,
              _originalData: contactData,
              customer_name: `${contactData.firstname || ""} ${contactData.lastname || ""
                }`.trim(),
              email: contactData.emailAddresses?.[0] || "",
              allEmails: contactData.emailAddresses || [],
              phone: contactData.phoneNumbers?.[0]
                ? `${contactData.phoneNumbers[0].countryCode || ""} ${contactData.phoneNumbers[0].number || ""
                  }`.trim()
                : "",
              allPhones:
                contactData.phoneNumbers?.map((p) =>
                  `${p.countryCode || ""} ${p.number || ""}`.trim()
                ) || [],
              customer_company: contactData.company || "",
              customer_occupation: contactData.designation || "",
              customer_image: contactData.contactImageURL || "",
              isFavourite: contactData.isFavourite || false,
              status: contactData.status,
              website: contactData.website || "",
              notes: contactData.notes || "",
              id: contactData.contact_id || contactData._id,
              key: contactData.contact_id || contactData._id,
            };

            dispatch(setSelectedContact(transformedData));
            setCustomerInfo(transformedData);


            // Set tags
            if (contactData.tags && contactData.tags.length > 0) {
              const mappedTags = contactData.tags.map((tag) => ({
                value: tag.tag_id,
                label: tag.tag,
                emoji: tag.emoji,
              }));

              setSelectedTags(mappedTags);
            }

            // Set default selected email and phone
            setSelectedEmail(transformedData.email);
            setSelectedPhone(transformedData.phone);
            // Set activities from contact data
            if (contactData.activities) {
              setActivities(contactData.activities);
            }

            fetchPipelineData(contact_id);
          }
        } catch (error) {
          console.error("❌ Error fetching contact details:", error);
          dispatch(
            showToast({
              message: "Failed to fetch contact details",
              variant: "danger",
            })
          );
        }
      } else {
        console.warn("⚠️ No valid contact identifier found in customerInfo");
      }
    };

    fetchContactDetails();
  }, []);


  // Fetch activities when component mounts
  useEffect(() => {
    if (
      customerInfo._originalData?.contact_id ||
      customerInfo.id ||
      customerInfo.key
    ) {
      fetchActivities();
    }
  }, [
    customerInfo._originalData?.contact_id,
    customerInfo.id,
    customerInfo.key,
  ]);

  // Fetch pipeline data
  const fetchPipelineData = async (contact_id) => {
    if (!contact_id) return;

    setLoadingPipeline(true);
    try {
      const pipelineData = await getContactPipeline(contact_id);
      setPipeline(pipelineData);
    } catch (error) {
      console.error("Error fetching pipeline:", error);
    } finally {
      setLoadingPipeline(false);
    }
  };

  useEffect(() => {
    const modalEl = document.getElementById("play_recording");

    if (!modalEl) return;

    const handleClose = () => {
      setAudioUrl(null);
    };

    modalEl.addEventListener("hidden.bs.modal", handleClose);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleClose);
    };
  }, []);

  const handlePlayRecording = async (fileName, rowKey) => {
    try {
      const response = await api.post("/call/recording", {
        record_file: fileName,
      });
      if (response.data?.fileUrl) {
        setAudioUrl(response.data.fileUrl);
        setActiveRowKey(rowKey); // mark this row as active
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePhoneClick = (phone) => {
    dispatch(openDialer());
    dispatch(setPhoneNumber(phone));
  };

  // Handle favorite toggle
  const handleFavoriteToggle = async () => {
    try {
      setIsFavLoading(true)
      const newFavoriteStatus = !customerInfo.isFavourite;
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const response = await toggleContactFavorite(
        contact_id,
        newFavoriteStatus,
        "contact"
      );

      if (response.status === "success") {
        setCustomerInfo((prev) => ({
          ...prev,
          isFavourite: newFavoriteStatus,
        }));
        dispatch(clearContactDetailsCache(contact_id));

        ///update the contact in list
        dispatch(
          updateContactInCache({
            contact_id,
            updates: {
              isFavourite: newFavoriteStatus,
            },
          })
        );

        dispatch(
          showToast({
            message: newFavoriteStatus
              ? "Added to favorites"
              : "Removed from favorites",
            variant: "success",
          })
        );
        setIsFavLoading(false)
        // Refresh activities
        fetchActivities();
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
      setIsFavLoading(false)
      dispatch(
        showToast({
          message: "Failed to update favorite status",
          variant: "danger",
        })
      );
    }
  };

  // Handle delete contact
  const handleDeleteContact = async () => {
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const response = await deleteContactOrLead(contact_id, "contact");

      if (response.status === "success") {
        dispatch(
          showToast({
            message: "Contact deleted successfully",
            variant: "success",
          })
        );

        // Navigate back to contact list
        navigate(route.contactList);
      }
    } catch (error) {
      console.error("Error deleting contact:", error);
      dispatch(
        showToast({
          message: "Failed to delete contact",
          variant: "danger",
        })
      );
    } finally {
      setOpenModal(false);
    }
  };

  // Handle tags update
  const handleTagsChange = async (newTags) => {
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const tagsData = newTags.map((tag, index) => ({
        tag_id: tag.value,
        tag: tag.label,
        emoji: tag.emoji || "🏷️",
        order: index,
      }));

      const response = await updateContactTags({
        contact_id,
        tags: tagsData,
        category: "contact",
      });

      if (response.status === "success") {
        setSelectedTags(newTags);
        dispatch(
          showToast({
            message: "Tags updated successfully",
            variant: "success",
          })
        );

        // Refresh activities
        fetchActivities();
      }
    } catch (error) {
      console.error("Error updating tags:", error);
      dispatch(
        showToast({
          message: "Failed to update tags",
          variant: "danger",
        })
      );
    }
  };

  // Handle offcanvas close and refresh data
  const handleOffcanvasClose = async (contact_id, updatedData) => {
    // Refresh contact data after offcanvas closes
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      // Clear contact details cache to force refetch
      dispatch(clearContactDetailsCache(contact_id));
      // Refresh activities
      fetchActivities();
      if (updatedData && contact_id) {
        // Build transformed data directly from updatedData
        const transformedData = {
          ...customerInfo,
          _originalData: updatedData,
          customer_name: `${updatedData.firstname || ""} ${updatedData.lastname || ""
            }`.trim(),
          email: updatedData.emailAddresses?.[0] || "",
          allEmails: updatedData.emailAddresses || [],
          phone: updatedData.phoneNumbers?.[0]
            ? `${updatedData.phoneNumbers[0].countryCode || ""} ${updatedData.phoneNumbers[0].number || ""
              }`.trim()
            : "",
          allPhones:
            updatedData.phoneNumbers?.map((p) =>
              `${p.countryCode || ""} ${p.number || ""}`.trim()
            ) || [],
          customer_company: updatedData.company || "",
          customer_occupation: updatedData.designation || "",
          customer_image: updatedData.contactImageURL || "",
          isFavourite: updatedData.isFavourite || false,
          status: updatedData.status,
          website: updatedData.website || "",
          notes: updatedData.notes || "",

          // Use the parameter contact_id
          id: contact_id,
          key: contact_id,
        };
        setCustomerInfo(transformedData);
        dispatch(setSelectedContact(transformedData));

        // Also update the contact in list cache optimistically
        dispatch(
          updateContactInCache({
            contact_id,
            updates: {
              firstname: updatedData.firstname,
              lastname: updatedData.lastname,
              company: updatedData.company,
              designation: updatedData.designation,
              emailAddresses: updatedData.emailAddresses,
              phoneNumbers: updatedData.phoneNumbers,
              website: updatedData.website,
              notes: updatedData.notes,
              isFavourite: updatedData.isFavourite,
              isLead: updatedData.isLead,
              contactImageURL: updatedData.contactImageURL,
              status: updatedData.status,
            },
          })
        );

        // Refetch pipeline data after contact update
        fetchPipelineData(contact_id);
      }
    } catch (error) {
      console.error("Error refreshing contact data:", error);
    }
  };

  // Fetch tasks for the contact
  const fetchTasks = async () => {
    setLoadingTasksFetch(true);
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      // Fetch from Redux cache or API
      const result = await dispatch(
        fetchTasksWithCache({ contact_id, sortBy: taskSortOrder })
      );
      const response = result.payload;

      if (response && response.data) {
        setTasks(response.data.tasks || []);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      dispatch(
        showToast({
          message: "Failed to fetch notes",
          variant: "danger",
        })
      );
    } finally {
      setLoadingTasksFetch(false);
    }
  };

  // Fetch tasks when component mounts or sort order changes
  useEffect(() => {
    if (
      customerInfo._originalData?.contact_id ||
      customerInfo.id ||
      customerInfo.key
    ) {
      fetchTasks();
    }
  }, [
    customerInfo._originalData?.contact_id,
    customerInfo.id,
    customerInfo.key,
    taskSortOrder,
  ]);

  // Handle task form submission
  const handleTaskSubmit = async (e) => {
    e.preventDefault();

    if (!taskFormData.taskDescription.trim()) {
      dispatch(
        showToast({
          message: "Note description is required",
          variant: "danger",
        })
      );
      return;
    }

    setLoadingTasksSubmit(true);
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const taskData = {
        contact_id,
        taskDescription: taskFormData.taskDescription,
        taskDueDate:
          contactedToday && taskFormData.taskDueDate
            ? taskFormData.taskDueDate.toISOString()
            : null,
        taskDueTime: contactedToday ? taskFormData.taskDueTime : null,
        taskIsCompleted: taskFormData.taskIsCompleted || false,
      };

      // If editing, add task_id
      if (taskToEdit) {
        taskData.task_id = taskToEdit.task_id;
      }

      taskData.category = "contact";

      const response = await addOrUpdateTask(taskData);

      if (response.status === "success") {
        dispatch(
          showToast({
            message: taskToEdit
              ? "Note updated successfully"
              : "Note added successfully",
            variant: "success",
          })
        );

        // Clear tasks cache for this contact
        dispatch(clearTasksCache(contact_id));

        // Refresh activities
        fetchActivities();

        // Reset form and fetch tasks
        setTaskFormData({
          taskDescription: "",
          taskDueDate: null,
          taskDueTime: "",
          taskIsCompleted: false,
        });
        setContactedToday(false);
        setTaskToEdit(null);
        fetchTasks();
      }
    } catch (error) {
      console.error("Error saving note:", error);
      dispatch(
        showToast({
          message: "Failed to save note",
          variant: "danger",
        })
      );
    } finally {
      setLoadingTasksSubmit(false);
    }
  };

  // Handle task delete
  const handleTaskDelete = async () => {
    if (!taskToDelete) return;

    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const response = await deleteTask({
        contact_id,
        task_id: taskToDelete.task_id,
        category: "contact",
      });

      if (response.status === "success") {
        dispatch(
          showToast({
            message: "Task deleted successfully",
            variant: "success",
          })
        );

        // Clear tasks cache for this contact
        dispatch(clearTasksCache(contact_id));

        setTaskToDelete(null);
        setDeleteModalText("");
        fetchTasks();

        // Refresh activities
        fetchActivities();
      }
    } catch (error) {
      console.error("Error deleting task:", error);
      dispatch(
        showToast({
          message: "Failed to delete task",
          variant: "danger",
        })
      );
    }
  };

  // Handle task edit click
  const handleTaskEditClick = (task) => {
    setTaskToEdit(task);

    // Parse the date properly - Ant Design DatePicker needs dayjs objects
    let parsedDate = null;
    if (task.taskDueDate) {
      parsedDate = dayjs(task.taskDueDate);
    }

    setTaskFormData({
      taskDescription: task.taskDescription || "",
      taskDueDate: parsedDate,
      taskDueTime: task.taskDueTime || "",
      taskIsCompleted: task.taskIsCompleted || false,
    });

    if (task.taskDueDate) {
      setContactedToday(true);
    }
  };

  // Handle task completion toggle
  const handleTaskCompletionToggle = async (task) => {
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const response = await addOrUpdateTask({
        contact_id,
        task_id: task.task_id,
        taskDescription: task.taskDescription,
        taskDueDate: task.taskDueDate,
        taskDueTime: task.taskDueTime,
        taskIsCompleted: !task.taskIsCompleted,
        category: "contact",
      });

      if (response.status === "success") {
        dispatch(
          showToast({
            message: task.taskIsCompleted
              ? "Note marked as incomplete"
              : "Note marked as completed",
            variant: "success",
          })
        );

        // Clear tasks cache for this contact
        dispatch(clearTasksCache(contact_id));
        fetchTasks();
        fetchActivities();
      }
    } catch (error) {
      console.error("Error updating task:", error);
      dispatch(
        showToast({
          message: "Failed to update task",
          variant: "danger",
        })
      );
    }
  };

  // ==================== MEETINGS HANDLERS ====================

  // Fetch meetings for the contact
  const fetchMeetings = async () => {
    setLoadingMeetings(true);
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      // Fetch from Redux cache or API
      const result = await dispatch(
        fetchMeetingsWithCache({ contact_id, sortBy: meetingSortOrder })
      );
      const response = result.payload;

      if (response && response.data) {
        setMeetings(response.data.meetings || []);
      }
    } catch (error) {
      console.error("Error fetching meetings:", error);
      dispatch(
        showToast({
          message: "Failed to fetch meetings",
          variant: "danger",
        })
      );
    } finally {
      setLoadingMeetings(false);
    }
  };

  // Fetch meetings when component mounts or sort order changes
  useEffect(() => {
    if (
      customerInfo._originalData?.contact_id ||
      customerInfo.id ||
      customerInfo.key
    ) {
      fetchMeetings();
    }
  }, [
    customerInfo._originalData?.contact_id,
    customerInfo.id,
    customerInfo.key,
    meetingSortOrder,
  ]);

  // Handle meeting form submission
  const handleMeetingSubmit = async (e) => {
    e.preventDefault();
    setIsMeetingLoading(true)
    if (!meetingFormData.meetingTitle.trim()) {
      dispatch(
        showToast({
          message: "Meeting title is required",
          variant: "danger",
        })
      );
      return;
    }

    if (!meetingFormData.meetingStartDate) {
      dispatch(
        showToast({
          message: "Meeting start date is required",
          variant: "danger",
        })
      );
      return;
    }

    // Validate online meeting provider and account connection
    if (meetingFormData.meetingType === "online") {
      if (!meetingFormData.meetingProvider) {
        dispatch(
          showToast({
            message: "Please select a meeting provider (Zoom or Google Meet)",
            variant: "danger",
          })
        );
        return;
      }

      // Check if the selected provider account is connected
      if (meetingFormData.meetingProvider === "zoom") {
        const zoomAccount = userProfile?.accounts?.crm?.find(
          (acc) => acc.type === "zoom"
        );
        if (!zoomAccount?.isConnected) {
          dispatch(
            showToast({
              message:
                "Please connect your Zoom account in Settings > Sync and Integration",
              variant: "danger",
            })
          );
          return;
        }
      }

      if (meetingFormData.meetingProvider === "google") {
        const googleAccount = userProfile?.accounts?.email?.find(
          (acc) => acc.type === "google"
        );
        if (!googleAccount?.isConnected) {
          dispatch(
            showToast({
              message:
                "Please connect your Google account in Settings > Sync and Integration",
              variant: "danger",
            })
          );
          return;
        }
      }
    }

    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const meetingData = {
        contact_id,
        meetingTitle: meetingFormData.meetingTitle,
        meetingDescription: meetingFormData.meetingDescription,
        meetingStartDate: meetingFormData.meetingStartDate
          ? meetingFormData.meetingStartDate.toISOString()
          : null,
        meetingStartTime: meetingFormData.meetingStartTime || null,
        meetingType: meetingFormData.meetingType || "offline",
        meetingProvider:
          meetingFormData.meetingType === "online"
            ? meetingFormData.meetingProvider
            : undefined,
        meetingLocation:
          meetingFormData.meetingType === "offline"
            ? meetingFormData.meetingLocation
            : undefined,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      // If editing, add meeting_id
      if (meetingToEdit) {
        meetingData.meeting_id = meetingToEdit.meeting_id;
      }

      meetingData.category = "contact";

      const response = await addOrUpdateMeeting(meetingData);

      setIsMeetingLoading(false)
      if (response.status === "success") {
        dispatch(
          showToast({
            message: meetingToEdit
              ? "Meeting updated successfully"
              : "Meeting added successfully",
            variant: "success",
          })
        );
closeMeetingRef.current?.click();
        // Clear meetings cache for this contact
        dispatch(clearMeetingsCache(contact_id));

        // Clear global events cache so calendar/events are refetched
        dispatch(clearEventsCache());

        // Refresh activities
        fetchActivities();

        // Reset form and fetch meetings
        setMeetingFormData({
          meetingTitle: "",
          meetingDescription: "",
          meetingStartDate: null,
          meetingStartTime: "",
          meetingType: "offline",
          meetingLocation: "",
          meetingProvider: null,
        });
        setMeetingToEdit(null);
        setSelectedMeetingType(null);
        fetchMeetings();
      }
    } catch (error) {
      console.error("Error saving meeting:", error);
      setIsMeetingLoading(false)
      dispatch(
        showToast({
          message: error.response?.data?.message || "Failed to save meeting",
          variant: "danger",
        })
      );
    }
  };

  // Handle meeting delete
  const handleMeetingDelete = async () => {
    if (!meetingToDelete) return;

    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const response = await deleteMeeting({
        contact_id,
        meeting_id: meetingToDelete.meeting_id,
        category: "contact",
      });

      if (response.status === "success") {
        dispatch(
          showToast({
            message: "Meeting deleted successfully",
            variant: "success",
          })
        );

        // Clear meetings cache for this contact
        dispatch(clearMeetingsCache(contact_id));

        // Clear global events cache so calendar/events are refetched
        dispatch(clearEventsCache());

        setMeetingToDelete(null);
        fetchMeetings();

        // Refresh activities
        fetchActivities();
      }
    } catch (error) {
      console.error("Error deleting meeting:", error);
      dispatch(
        showToast({
          message: "Failed to delete meeting",
          variant: "danger",
        })
      );
    }
  };

  // Handle meeting edit click
  const handleMeetingEditClick = (meeting) => {
    setMeetingToEdit(meeting);

    // Parse the date properly
    let parsedDate = null;
    if (meeting.meetingStartDate) {
      parsedDate = dayjs(meeting.meetingStartDate);
    }

    setMeetingFormData({
      meetingTitle: meeting.meetingTitle || "",
      meetingDescription: meeting.meetingDescription || "",
      meetingStartDate: parsedDate,
      meetingStartTime: meeting.meetingStartTime || "",
      meetingType: meeting.meetingType || "offline",
      meetingLocation: meeting.meetingLocation || "",
      meetingProvider: meeting.meetingProvider || null,
    });

    setSelectedMeetingType(
      meeting.meetingType === "online" ? "Online" : "Offline"
    );
  };

  // Get filtered and sorted activities
  const getFilteredAndSortedActivities = () => {
    let filtered = [...activities];

    // Filter by activity type
    if (activityFilter && activityFilter !== "all") {
      filtered = filtered.filter(
        (activity) => activity.type === activityFilter
      );
    }

    // Sort by timestamp
    filtered.sort((a, b) => {
      const dateA = new Date(a.timestamp);
      const dateB = new Date(b.timestamp);
      return activitySortOrder === "ascending" ? dateA - dateB : dateB - dateA;
    });

    return filtered;
  };
  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);
  // Get activity icon and color based on type
  const getActivityIconAndColor = (type) => {
    const icons = {
      contact: { icon: "ti ti-user-pin", color: "bg-info" },
      task: { icon: "ti ti-notes", color: "bg-orange" },
      meeting: { icon: "ti ti-calendar-event", color: "bg-info" },
      tag: { icon: "ti ti-tag", color: "bg-purple" },
      email: { icon: "ti ti-mail-code", color: "bg-pending" },
      whatsapp: { icon: "ti ti-brand-whatsapp", color: "bg-success" },
      call: { icon: "ti ti-phone", color: "bg-secondary-success" },
    };
    return icons[type] || { icon: "ti ti-circle", color: "bg-secondary" };
  };



  const assignTags = async () => {

    const payload = {
      contact_id: customerInfo._originalData?.contact_id,
      category: "contact",
      tags: selectedTags.map((tag) => ({
        tag: tag.value,
        emoji: tag.emoji,
      })),
    };

    try {
      if (newTags.length > 0) {
        await dispatch(addTag(newTags)).unwrap();
      }

      const response = await api.post("/tag/assignedToContact", payload)

      dispatch(
        showToast({
          message: "Tags assigned to selected contacts",
          variant: "success",
        })
      );

      // Reset bulk state
      // setBulkSelectedTags([]);
      // setBulkNewTags([]);
      // onClose?.();
    } catch (error) {
      dispatch(
        showToast({
          message: "Failed to assign tags",
          variant: "danger",
        })
      );
      console.error(error);
    } finally {
      // setBulkIsLoading(false);
    }
  };



  // Handle notes update
  const handleNotesUpdate = async () => {
    try {
      const contact_id =
        customerInfo._originalData?.contact_id ||
        customerInfo.id ||
        customerInfo.key;

      const formData = new FormData();
      formData.append("contact_id", contact_id);
      formData.append("notes", customerInfo.notes || "");
      formData.append("firstname", customerInfo._originalData?.firstname || "");
      formData.append("lastname", customerInfo._originalData?.lastname || "");
      formData.append("company", customerInfo._originalData?.company || "");
      formData.append(
        "designation",
        customerInfo._originalData?.designation || ""
      );
      formData.append("website", customerInfo._originalData?.website || "");
      formData.append(
        "isFavourite",
        customerInfo._originalData?.isFavourite || false
      );
      formData.append("isLead", customerInfo._originalData?.isLead || false);
      formData.append(
        "emailAddresses",
        JSON.stringify(customerInfo._originalData?.emailAddresses || [])
      );
      formData.append(
        "phoneNumbers",
        JSON.stringify(customerInfo._originalData?.phoneNumbers || [])
      );
      formData.append("category", "contact");

      const response = await addEditContactOrLead(formData);

      if (response.status === "success") {
        dispatch(
          showToast({
            message: "Notes updated successfully",
            variant: "success",
          })
        );
        handleOffcanvasClose(); // Refresh contact data
      }
    } catch (error) {
      console.error("Error updating notes:", error);
      dispatch(
        showToast({
          message: "Failed to update notes",
          variant: "danger",
        })
      );
    }
  };

  const handleModalDeleteBtn = (text) => {
    if (text === "note") {
      handleTaskDelete();
    } else if (text === "meeting") {
      handleMeetingDelete();
    }
    // Add other deletion types here (note, etc.)
  };
  const initializeStarsState = () => {
    const starsState = {};
    leadsData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };
  React.useEffect(() => {
    initializeStarsState();
  }, []);
  const handleStarToggle = (index) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const filteredEmployees = companyEmployee.filter((employee) =>
    employee.value.toLowerCase().includes(searchEmployeeInFilter.toLowerCase())
  );
  const currentDateAndTime = new Date();
  const currentDate = currentDateAndTime.toLocaleDateString();
  const currentTime = currentDateAndTime.toLocaleTimeString();
  const exportPDF = () => {
    const doc = new jsPDF();

    const filteredColumns = columns.filter(
      (col) => columnVisibility[col.title] && col.title !== "Recording"
    );

    const headers = filteredColumns.map((col) => col.title);
    const data = filteredCallData.map((row) =>
      filteredColumns.map((col) => {
        const value = row[col.dataIndex];

        if (col.dataIndex === "start_time") return formatCallDate(value);
        if (col.dataIndex === "duration") return formatCallDuration(value);

        return value || "";
      })
    );

    const pageWidth = doc.internal.pageSize.getWidth();
    const titleText = "Calls Report";
    const titleWidth = doc.getTextWidth(titleText);
    const titleX = (pageWidth - titleWidth) / 2;

    doc.setFontSize(15);
    doc.text(titleText, titleX, 20);

    doc.setFontSize(10);
    doc.text(`Exported on: ${currentDate} at ${currentTime}`, 15, 35);

    autoTable(doc, {
      startY: 40,
      head: [headers],
      body: data,
    });

    doc.save("Call-details.pdf");
  };

  const exportExcel = () => {
    const wb = utils.book_new();

    const filteredColumns = columns.filter(
      (col) => columnVisibility[col.title] && col.title !== "Recording"
    );

    const wsData = [
      filteredColumns.map((col) => col.title),
      ...filteredCallData.map((row) =>
        filteredColumns.map((col) => {
          const value = row[col.dataIndex];
          if (col.dataIndex === "start_time") return formatCallDate(value);
          if (col.dataIndex === "duration") return formatCallDuration(value);

          return value || "";
        })
      ),
    ];

    const ws = utils.aoa_to_sheet(wsData);

    utils.book_append_sheet(wb, ws, "Calls");

    writeFile(wb, "calls_report.xlsx");
  };
  const handleToggleColumnVisibility = (columnTitle) => {
    setColumnVisibility((prevVisibility) => ({
      ...prevVisibility,
      [columnTitle]: !prevVisibility[columnTitle],
    }));
  };

  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
  };

  const [selectedDate, setSelectedDate] = useState(new Date());
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [selectedDate2, setSelectedDate2] = useState(new Date());
  const handleDateChange2 = (date) => {
    setSelectedDate2(date);
  };
  const [selectedDate4, setSelectedDate4] = useState(new Date());
  const handleDateChange4 = (date) => {
    setSelectedDate4(date);
  };
  const handleCustomerEditClick = (record) => {
    setSelectedCustomer(record);
  };

  const filteredCallData = callLogs.filter((calls) => {
    return calls;
  });
  const filterLeadEmployee = (leadEmployee) => {
    setSelectedEmployee((prevStatus) =>
      prevStatus.includes(leadEmployee)
        ? prevStatus.filter((employee) => employee !== leadEmployee)
        : [...prevStatus, leadEmployee]
    );
  };

  const initialSettings = {
    // endDate: now,

    ranges: {
      "Last 30 Days": [last30Start, now],
      "Last 7 Days": [last7Start, now],
      "Last Month": [lastMonthStart, lastMonthEnd],
      "This Month": [thisMonthStart, thisMonthEnd],
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
    },

    startDate: dayjs(last7Start).toDate(), // JS Date
    endDate: dayjs(today).toDate(), // JS Date
    timePicker: false,
  };

  const handleUserTags = (tags) => {
    setSelectedTags(tags);

    // const tagsForApi = tags.map((tag) => tag.value);

    const removedTagsFilter = previousTags
      .filter((prevTag) => !tags.some((tag) => tag.value === prevTag.value))
      .map((tag) => tag.value);
    setRemovedTags(removedTagsFilter);
  };

  const handleCreateTag = async (inputValue) => {
    setNewTags([...newTags, { tag: inputValue, emoji: "🏷️" }]);
    setSelectedTags([
      ...selectedTags,
      { value: inputValue, label: `🏷️ ${inputValue}`, emoji: "🏷️" },
    ]);
  };
  const columns = [
    // {
    //   title: "",
    //   dataIndex: "",
    //   render: (text, record, index) => (
    //     <div
    //       className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
    //       onClick={() => handleStarToggle(index)}
    //     >
    //       <i className="fa fa-star"></i>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Call Id",
    //   dataIndex: "callId",
    //   key: "callId",
    //   sorter: (a, b) => a.callId.localeCompare(b.callId),
    // },
    // {
    //   title: "Agent Name",
    //   dataIndex: "agentName",
    //   key: "agentName",
    //   sorter: (a, b) => a.agentName.localeCompare(b.agentName),
    // },
    // {
    //   title: "Call Date",
    //   dataIndex: "callDate",
    //   key: "callDate",
    //   sorter: (a, b) => a.callDate.localeCompare(b.callDate),
    // },
    ...(userProfile.role === "companyAdmin" ? [
      {
        title: "Agent Name",
        dataIndex: "ownerName",
        key: "ownerName",
        render: (text) => <div>{text || "—"}</div>,
      },
      {
        title: "Extension",
        dataIndex: "extensionNumber",
        key: "extensionNumber",
        render: (text) => <div>{text || "—"}</div>,
      },
    ] : [
      {
        title: "Extension",
        dataIndex: "extensionNumber",
        key: "extensionNumber",
        render: (text) => <div>{text || "—"}</div>,
      },
    ]),
    {
      title: "Call Date",
      dataIndex: "start_time",
      key: "start_time",
      render: (text, record, index) => {
        return <div>{formatCallDate(text)}</div>;
      },
      sorter: (a, b) => a.start_time.localeCompare(b.start_time),
    },
    {
      title: "Call Duration",
      dataIndex: "duration",
      key: "duration",
      render: (text, record, index) => {
        if (!text) return <div>-</div>;
        return <div>{formatCallDuration(text)}</div>;
      },
      sorter: (a, b) => Number(a.duration || 0) - Number(b.duration || 0),
    },
    {
      title: "Call Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Direction",
      dataIndex: "direction",
      key: "direction",
      sorter: (a, b) => a.direction.localeCompare(b.direction),
    },
    ...(userProfile.role === "companyAdmin" ? [
      {
        title: "Charges",
        dataIndex: "charges",
        key: "charges",
        render: (val) => <div>{val != null ? `$${Number(val).toFixed(4)}` : "—"}</div>,
      },
    ] : []),
    {
      title: "Recording",
      dataIndex: "record_file",
      key: "record_file",
      render: (text, record) => {
        if (!text) return <div className="text-center">-</div>;

        return (
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex justify-content-center align-items-center">
              <span style={{ color: "#00918E" }} className="me-3">
                <FaCloudDownloadAlt />
              </span>
              <span
                style={{ color: "blue", cursor: "pointer" }}
                data-bs-toggle="modal"
                data-bs-target="#play_recording"
                onClick={() => handlePlayRecording(text, record.key)}
              >
                <CiPlay1 />
              </span>
            </div>
          </div>
        );
      },
    },
  ];
  const visibleColumns = columns.filter(
    (column) => columnVisibility[column.title]
  );
  const filterCallStatus = (callStatus) => {
    setSelectedCallStatus((prevStatus) =>
      prevStatus.includes(callStatus)
        ? prevStatus.filter((status) => status !== callStatus)
        : [...prevStatus, callStatus]
    );
  };

  const handleRefreshCalls = async () => {
    setIsRefreshingCalls(true);
    try {
      // First, fetch and store new data from Yeastar
      await api.post("call/fetch-and-store");

      // Then, refresh the call history with the updated data
      const payload = {
        searchQuery,
        status: selectedCallStatus,
        startDate,
        endDate,
        callDirection: selectedCallDirection,
        phone_number: customerInfo?.phoneNumber,
        page: 1,
        page_size: 10,
      };
      await dispatch(fetchCallHistoryNumber(payload));
    } catch (error) {
      console.error("Error refreshing call history:", error);
    } finally {
      setIsRefreshingCalls(false);
    }
  };
  const filterCallDirection = (callDirection) => {
    setSelectedCallDirection((prevDirection) =>
      prevDirection.includes(callDirection)
        ? prevDirection.filter((direction) => direction !== callDirection)
        : [...prevDirection, callDirection]
    );
  };
  const resetFilters = () => {
    setSelectedCallStatus([]);
    setSelectedEmployee([]);
    setSearchEmployeeInFilter("");
  };
  dayjs.extend(customParseFormat);
  const onChange = (time, timeString) => {
  };
  const getInitials = (customer_name) => {
    if (customer_name) {
      const parts = customer_name.trim().split(" ");
      const firstName = parts[0] || "";
      const lastName = parts[1] || "";
      if (lastName) {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
      }
      return `${firstName.charAt(0)}${firstName.charAt(1) || ""}`.toUpperCase();
    }
  };
  const handleInput = (event) => {
    const input = event.target.value;
    if (selectedTask) {
      setSelectedTask({
        ...selectedTask,
        title: input,
      });
    }
  };
  const handleNoteEditClick = (note) => {
    setSelectedNote(note);
  };
  const handleMeetingTypeChange = (selectedOption) => {
    setSelectedMeetingType(selectedOption ? selectedOption.value : null);
  };
  const onDrop = useCallback((acceptedFiles) => {
    // Handle the uploaded files here
    setUploadedFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // accept: {
    //   "text/csv": ['.csv'],
    //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ['.xlsx']
    // },
    maxSize: 5242880, // 5MB max file size
    multiple: true,
  });
  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];
  // Activity filter options
  const activityFilterOptions = [
    { value: "all", label: "All Activities" },
    { value: "contact", label: "Contact Updates" },
    { value: "task", label: "Note Activities" },
    { value: "meeting", label: "Meeting Activities" },
    { value: "tag", label: "Tag Changes" },
    { value: "email", label: "Emails" },
    { value: "whatsapp", label: "WhatsApp" },
    // { value: "call", label: "Calls" },
  ];

  const industries = [
    { value: "choose", label: "Choose" },
    { value: "Retail Industry", label: "Retail Industry" },
    { value: "Banking", label: "Banking" },
    { value: "Hotels", label: "Hotels" },
    { value: "Financial Services", label: "Financial Services" },
    { value: "Insurance", label: "Insurance" },
  ];
  const countries = [
    { value: "Choose", label: "Choose" },
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "France", label: "France" },
    { value: "UAE", label: "UAE" },
  ];
  const languages = [
    { value: "Choose", label: "Choose" },
    { value: "English", label: "English" },
    { value: "Arabic", label: "Arabic" },
    { value: "Chinese", label: "Chinese" },
    { value: "Hindi", label: "Hindi" },
  ];
  const handlePageChange = (page, pageSize) => {
    dispatch(
      fetchCallHistoryNumber({
        page,
        page_size: pageSize,
        search: searchQuery,
        status: selectedCallStatus,
        phonenumbers: formattedPhones,
        // direction: directionFilter,
        startDate,
        endDate,
      })
    );
  };
  const handleRadioChange = (event) => {
    setContactedToday(event.target.value === "contactedToday");
  };
  const sortNotes = (notes) => {
    const sortedNotes = [...notes];
    const parseDate = (dateString) => {
      const [day, month, year, time, meridiem] = dateString.split(/[\s,]+/);
      const formattedDate = `${day} ${month} ${year} ${time} ${meridiem}`;
      return new Date(formattedDate).getTime();
    };
    if (sortOrder === "Ascending") {
      sortedNotes.sort(
        (a, b) => parseDate(a.dateCreated) - parseDate(b.dateCreated)
      );
    } else if (sortOrder === "Descending") {
      sortedNotes.sort(
        (a, b) => parseDate(b.dateCreated) - parseDate(a.dateCreated)
      );
    }
    return sortedNotes;
  };
  const sortIncompleteTask = (incompleteTask) => {
    const sortedIncompleteTask = [...incompleteTask];
    const parseDate = (dateString) => {
      const [day, month, year, time, meridiem] = dateString.split(/[\s,]+/);
      const formattedDate = `${day} ${month} ${year} ${time} ${meridiem}`;
      return new Date(formattedDate).getTime();
    };
    if (sortOrderIncompleteTask === "Ascending") {
      sortedIncompleteTask.sort(
        (a, b) => parseDate(a.dateCreated) - parseDate(b.dateCreated)
      );
    } else if (sortOrderIncompleteTask === "Descending") {
      sortedIncompleteTask.sort(
        (a, b) => parseDate(b.dateCreated) - parseDate(a.dateCreated)
      );
    }
    return sortedIncompleteTask;
  };
  const sortCompletedTask = (completedTask) => {
    const sortedCompletedTask = [...completedTask];
    const parseDate = (dateString) => {
      const [day, month, year, time, meridiem] = dateString.split(/[\s,]+/);
      const formattedDate = `${day} ${month} ${year} ${time} ${meridiem}`;
      return new Date(formattedDate).getTime();
    };
    if (sortOrderCompletedTask === "Ascending") {
      sortedCompletedTask.sort(
        (a, b) => parseDate(a.dateCreated) - parseDate(b.dateCreated)
      );
    } else if (sortOrderCompletedTask === "Descending") {
      sortedCompletedTask.sort(
        (a, b) => parseDate(b.dateCreated) - parseDate(a.dateCreated)
      );
    }
    return sortedCompletedTask;
  };

  const sortedNotes = sortNotes(allNotes);
  const sortedIncompleteTask = sortIncompleteTask(allTasks);
  const sortedCompletedTask = sortCompletedTask(allTasks);
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Contact User */}
              <div className="contact-head">
                <div className="row align-items-center">
                  <div className="col-sm-6">
                    <ul className="contact-breadcrumb">
                      <li>
                        <Link
                          to={
                            userProfile.role === "user"
                              ? route.agentContactList
                              : route.contactList
                          }
                        >
                          <i className="ti ti-arrow-narrow-left" />
                          Contacts
                        </Link>
                      </li>
                      <li>{customerInfo.customer_name || "N/A"}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <button
                ref={closeMeetingRef}
                type="button"
                data-bs-dismiss="modal"
                style={{ display: "none" }}
              >
              </button>
              <div className="card">
                <div className="card-body pb-2">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center mb-2">
                      {customerInfo.customer_image ? (
                        <div className="avatar avatar-xl online online-sm me-3 flex-shrink-0">
                          <img src={customerInfo.customer_image} alt="img" />
                          <span className="status online" />
                        </div>
                      ) : (
                        // <span className="avatar avatar-lg bg-gray flex-shrink-0 me-2">
                        //   <span className="avatar-title text-dark">
                        //     {getInitials(customerInfo.customer_name)}
                        //   </span>
                        // </span>
                        <AvatarInitialStyles
                          name={`${customerInfo.firstname} ${customerInfo.lastname}`}
                          divStyles={{ width: 70, height: 70, borderRadius: 10, fontSize: 20 }}
                        />
                      )}
                      <div className="ms-3">
                        <h5 className="mb-0">
                          {customerInfo.customer_name || "N/A"}
                          {customerInfo.isVerified && (
                            <FcApproval className="ms-1" />
                          )}
                        </h5>
                        <div className="d-flex">
                          <span className="me-1 text-dark">
                            {customerInfo.customer_company}
                          </span>
                          <p className="mb-0">
                            (
                            {customerInfo.customer_occupation ||
                              "No Designation"}
                            )
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="contacts-action align-items-center mb-2">
                      {/* <Link to={route.leads} title="Quotation" className="btn-icon">
                        <LiaFileInvoiceDollarSolid />
                      </Link>
                      <Link to={route.leads} title="Invoice" className="btn-icon">
                        <TbInvoice />
                      </Link>
                      <Link to={route.leads} title="Payments" className="btn-icon">
                        <MdAttachMoney />
                      </Link>
                      <Link to={route.leads} title="Projects" className="btn-icon">
                        <GoProjectRoadmap />
                      </Link>
                      <Link to={route.leads} title="Ticket" className="btn-icon">
                        <IoTicketOutline />
                      </Link>

                      <Link to="" className="btn-icon rating">
                        <i className="fa-solid fa-star" />
                      </Link> */}
                      {/* <Link
                        to=""
                        className="btn btn-danger"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvas_add_2"
                      >
                        <i className="ti ti-circle-plus" />
                        Add Deal
                      </Link> */}

                      {customerInfo.allPhones &&
                        customerInfo.allPhones.length > 0 ? (
                        <Dropdown as={ButtonGroup}>
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              selectedPhone &&
                              handlePhoneClick(
                                selectedPhone || customerInfo.phone
                              )
                            }
                          >
                            <i className="typcn typcn-phone me-2" />
                            {selectedPhone ? (
                              <>
                                Call{" "}
                                <span className="ms-2">
                                  {"+" + selectedPhone}
                                </span>
                              </>
                            ) : (
                              "No Phone"
                            )}
                          </button>
                          <Dropdown.Toggle
                            split
                            className="text-white"
                            id="dropdown-split-basic"
                          />
                          <Dropdown.Menu>
                            {customerInfo.allPhones.map((phone, index) => (
                              <Dropdown.Item
                                key={index}
                                active={phone === selectedPhone}
                                style={{
                                  color:
                                    phone === selectedPhone ? "white" : "black",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setSelectedPhone(phone);
                                  // Close the dropdown
                                  const dropdown =
                                    e.currentTarget.closest(".dropdown");
                                  if (dropdown) {
                                    const toggleBtn =
                                      dropdown.querySelector(
                                        ".dropdown-toggle"
                                      );
                                    if (toggleBtn) toggleBtn.click();
                                  }
                                }}
                              >
                                +{phone}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : (
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            selectedPhone &&
                            handlePhoneClick(
                              selectedPhone || customerInfo.phone
                            )
                          }
                        >
                          <i className="typcn  typcn-phone me-2" />
                          {selectedPhone ? (
                            <>
                              Call{" "}
                              <span className="ms-2">
                                {"+" + selectedPhone}
                              </span>
                            </>
                          ) : (
                            "No Phone"
                          )}
                        </button>
                      )}
                      <Link
                        to=""
                        className="btn-icon mb-0 ms-2"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#customer_offcanvas"
                        onClick={() => {
                          handleCustomerEditClick(customerInfo);
                        }}
                      >
                        <CiEdit />
                      </Link>
                      <div className="act-dropdown mb-0">
                        <Link
                          to=""
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="ti ti-dots-vertical" />
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                          <Link
                            className="dropdown-item"
                            to=""
                            onClick={() => setOpenModal(true)}
                          >
                            <i className="ti ti-trash text-danger" />
                            Delete
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Contact User */}
            </div>
            {/* Contact Sidebar */}
            <div className="col-xl-3 theiaStickySidebar">
              <div className="card">
                <div className="card-body p-3">
                  <h6 className="mb-3 fw-semibold">Basic Information</h6>
                  <div className=" px-2 mb-4 d-flex flex-wrap gap-3 justify-content-start">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="tooltip-email">
                          {customerInfo.email
                            ? "Send Email"
                            : "Email not available"}
                        </Tooltip>
                      }
                    >
                      <span>
                        <Link
                          to="#"
                          data-bs-toggle={
                            customerInfo.email ? "modal" : undefined
                          }
                          data-bs-target={
                            customerInfo.email
                              ? "#show_email_templates"
                              : undefined
                          }
                          className={`icon-wrapper-sm mail ${!customerInfo.email ? "disabled-icon" : ""
                            }`}
                          onClick={(e) => {
                            if (!customerInfo.email) e.preventDefault();
                          }}
                        >
                          <img
                            src="/assets/img/icons/mailIcon.png"
                            alt="Mail"
                          />
                        </Link>
                      </span>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="tooltip-whatsapp">
                          {customerInfo.phone
                            ? "Send WhatsApp"
                            : "Phone number not available"}
                        </Tooltip>
                      }
                    >
                      <span>
                        <Link
                          to="#"
                          data-bs-toggle={
                            customerInfo.phone ? "modal" : undefined
                          }
                          data-bs-target={
                            customerInfo.phone
                              ? "#show_whatsapp_templates"
                              : undefined
                          }
                          className={`icon-wrapper-sm whatsapp no-filter ${!customerInfo.phone ? "disabled-icon" : ""
                            }`}
                          onClick={(e) => {
                            if (!customerInfo.phone) e.preventDefault();
                          }}
                        >
                          <img
                            src="/assets/img/icons/whatsappIcon96.png"
                            alt="WhatsApp"
                          />
                        </Link>
                      </span>
                    </OverlayTrigger>
                    {/* {[
                      "instagram",
                      "twitter",
                      "linkedin",
                      "facebook",
                      "telegram",
                    ].map((platform) => {
                      const platformLabel =
                        platform.charAt(0).toUpperCase() + platform.slice(1);
                      const isActive = !!leadInfo?.[platform];
                      const tooltipText = isActive
                        ? `Open ${platformLabel}`
                        : `Search on ${platformLabel}`;
                      const fullName = `${leadInfo?.firstname || ""} ${
                        leadInfo?.lastname || ""
                      }`.trim();

                      const searchUrls = {
                        instagram: `https://www.instagram.com/explore/search/keyword/?q=${encodeURIComponent(
                          fullName
                        )}`,
                        twitter: `https://twitter.com/search?q=${encodeURIComponent(
                          fullName
                        )}`,
                        linkedin: `https://www.linkedin.com/search/results/all/?keywords=${encodeURIComponent(
                          fullName
                        )}`,
                        facebook: `https://www.facebook.com/search/top?q=${encodeURIComponent(
                          fullName
                        )}`,
                        telegram: `https://t.me/s/${encodeURIComponent(
                          fullName.replace(/\s+/g, "_")
                        )}`,
                      };

                      const handleSocialClick = () => {
                        if (isActive) {
                          window.open(leadInfo[platform], "_blank");
                        } else if (fullName) {
                          window.open(searchUrls[platform], "_blank");
                        }
                      };

                      return (
                        <OverlayTrigger
                          key={platform}
                          placement="bottom"
                          overlay={
                            <Tooltip id={`tooltip-${platform}`}>
                              {tooltipText}
                            </Tooltip>
                          }
                        >
                          <span>
                            <div
                              className={`icon-wrapper-sm ${platform} no-filter ${
                                !isActive ? "disabled-icon" : ""
                              }`}
                              onClick={handleSocialClick}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="icon-stack">
                                <img
                                  src={`/assets/img/icons/${platform}Icon.png`}
                                  alt={platformLabel}
                                  className="main-icon"
                                />

                                <img
                                  src="/assets/img/icons/searchIcon.png"
                                  alt="Search"
                                  className="search-icon"
                                />
                              </span>
                            </div>
                          </span>
                        </OverlayTrigger>
                      );
                    })} */}
                  </div>
                  <div className="mb-3">
                    {/* Email Display */}
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-mail" />
                      </span>
                      <p className="mb-0" style={{ color: "#2c5cc5" }}>
                        {customerInfo.allEmails &&
                          customerInfo.allEmails.length > 0
                          ? customerInfo.allEmails.join(", ")
                          : "No email"}
                      </p>
                    </div>

                    {/* Phone Display */}
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-phone" />
                      </span>
                      <p className="mb-0" style={{ color: "#2c5cc5" }}>
                        {customerInfo.allPhones &&
                          customerInfo?.allPhones?.length > 0
                          ? customerInfo?.allPhones
                            .map((phone) => `+${phone}`)
                            .join(", ")
                          : "No phone"}
                        {/* {customerInfo.allPhones && customerInfo.allPhones.length > 0
                          ? customerInfo.allPhones
                            .map((phone) => `+${phone.countryCode} ${phone.number}`)
                            .join(", ")
                          : "No phone"} */}
                      </p>
                    </div>

                    {/* Website */}
                    {customerInfo.website && (
                      <div className="d-flex align-items-center mb-3">
                        <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                          <i className="ti ti-world" />
                        </span>
                        <a
                          href={
                            customerInfo.website.startsWith("http")
                              ? customerInfo.website
                              : `https://${customerInfo.website}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#2c5cc5" }}
                        >
                          {customerInfo.website}
                        </a>
                      </div>
                    )}

                    {/* Created On */}
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <i className="ti ti-calendar-exclamation" />
                      </span>
                      <p className="mb-0">
                        Created on {customerInfo.dateCreated}
                      </p>
                    </div>

                    {/* Status */}
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2">
                        <MdDoubleArrow />
                      </span>
                      <span
                        className="py-1"
                        style={{
                          fontSize: "12px",
                          padding: "4px 10px",
                          borderRadius: "12px",
                          fontWeight: 500,
                          ...getStatusStyle(customerInfo.status),
                        }}
                      >
                        {(() => {
                          try {
                            if (
                              typeof contactStatusOptions !== "undefined" &&
                              Array.isArray(contactStatusOptions)
                            ) {
                              const matched = contactStatusOptions.find(
                                (s) => s.value === customerInfo.status
                              );
                              if (matched && matched.label)
                                return matched.label;
                            }
                          } catch (e) {
                            // ignore lookup errors
                          }
                          return customerInfo.status || "Unknown";
                        })()}
                      </span>
                    </div>

                    {/* Notes */}
                    {/* {customerInfo.notes && (
                      <div className="mb-3">
                        <div className="d-flex align-items-start">
                          <span className="avatar avatar-xs bg-light-300 p-0 flex-shrink-0 rounded-circle text-dark me-2 mt-1">
                            <i className="ti ti-notes" />
                          </span>
                          <div>
                            <small className="text-muted d-block mb-1">
                              Notes:
                            </small>
                            <p className="mb-0 small">{customerInfo.notes}</p>
                          </div>
                        </div>
                      </div>
                    )} */}
                  </div>

                  <hr />

                  {/* Tags */}
                  <div className="mb-1 d-flex justify-content-between align-items-center">
                    <label className="col-form-label">Tags </label>
                    <button
                      className="btn btn-primary contacts-delete-btn ms-2 py-1"
                      onClick={assignTags}
                      style={{}}
                    >
                      Save
                    </button>
                  </div>
                  <div>
                    <CreatableSelect
                      classNamePrefix="react-select"
                      options={allTags}
                      value={selectedTags}
                      onChange={(newValue) => handleUserTags(newValue)}
                      onCreateOption={handleCreateTag}
                      className="js-example-placeholder-multiple select2 js-states"
                      isMulti={true}
                      placeholder="Add Tags"
                    />
                  </div>
                  <hr />

                  {/* Social Profile */}
                  {/* <h6 className="mb-3 fw-semibold">Social Profile</h6>
                  <ul className="social-info">
                    {customerInfo._originalData?.facebook && (
                      <li>
                        <Link
                          to={
                            customerInfo._originalData.facebook.startsWith(
                              "http"
                            )
                              ? customerInfo._originalData.facebook
                              : `https://facebook.com/${customerInfo._originalData.facebook}`
                          }
                          target="_blank"
                        >
                          <i className="fa-brands fa-facebook-f" />
                        </Link>
                      </li>
                    )}
                    {customerInfo._originalData?.instagram && (
                      <li>
                        <Link
                          to={
                            customerInfo._originalData.instagram.startsWith(
                              "http"
                            )
                              ? customerInfo._originalData.instagram
                              : `https://instagram.com/${customerInfo._originalData.instagram}`
                          }
                          target="_blank"
                        >
                          <i className="fa-brands fa-instagram" />
                        </Link>
                      </li>
                    )}
                    {customerInfo._originalData?.linkedin && (
                      <li>
                        <Link
                          to={
                            customerInfo._originalData.linkedin.startsWith(
                              "http"
                            )
                              ? customerInfo._originalData.linkedin
                              : `https://linkedin.com/in/${customerInfo._originalData.linkedin}`
                          }
                          target="_blank"
                        >
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                      </li>
                    )}
                    {customerInfo._originalData?.twitter && (
                      <li>
                        <Link
                          to={
                            customerInfo._originalData.twitter.startsWith(
                              "http"
                            )
                              ? customerInfo._originalData.twitter
                              : `https://twitter.com/${customerInfo._originalData.twitter}`
                          }
                          target="_blank"
                        >
                          <i className="fa-brands fa-twitter" />
                        </Link>
                      </li>
                    )}
                    {customerInfo._originalData?.telegram && (
                      <li>
                        <Link
                          to={
                            customerInfo._originalData.telegram.startsWith(
                              "http"
                            )
                              ? customerInfo._originalData.telegram
                              : `https://t.me/${customerInfo._originalData.telegram}`
                          }
                          target="_blank"
                        >
                          <i className="fa-brands fa-telegram" />
                        </Link>
                      </li>
                    )}
                    {!customerInfo._originalData?.facebook &&
                      !customerInfo._originalData?.instagram &&
                      !customerInfo._originalData?.linkedin &&
                      !customerInfo._originalData?.twitter &&
                      !customerInfo._originalData?.telegram && (
                        <li className="text-muted">No social profiles</li>
                      )}
                  </ul>

                  <hr /> */}

                  {/* Settings */}
                  <h6 className="mb-3 fw-semibold">Settings</h6>
                  <div className="mb-0">
                    <Link
                      to="#"
                      className="d-block mb-3"
                      onClick={(e) => {
                        e.preventDefault();
                        handleFavoriteToggle();
                      }}
                    >
                      {isFavLoading ?
                        <Spin indicator={<LoadingOutlined spin />} size="small" className="me-1" /> :
                        <i
                          className={`ti ti-star me-1 ${customerInfo.isFavourite ? "text-warning" : ""
                            }`}
                        />}
                      {customerInfo.isFavourite
                        ? "Remove from Favorite"
                        : "Add to Favorite"}
                    </Link>
                    <Link
                      to=""
                      className="d-block mb-0"
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenModal(true);
                      }}
                    >
                      <i className="ti ti-trash-x me-1" />
                      Delete Contact
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* /Contact Sidebar */}
            {/* Contact Details */}
            <div className="col-xl-9">
              <div className="card mb-3">
                <div className="card-body pb-0">
                  {/* <h4 className="fw-semibold mb-3">Contact Pipeline Status</h4>
                  <div className="pipeline-list">
                    {loadingPipeline ? (
                      <div className="text-center py-3">
                        <span>Loading pipeline...</span>
                      </div>
                    ) : pipeline.length > 0 ? (
                      <ul>
                        {pipeline.map((item, index) => {
                          // Define status colors
                          const statusColors = {
                            interested: "#ffe4b4",
                            contacted: "#bdf7ff",
                            win: "#d7ffd9",
                            lost: "#ffdbdb",
                            called: "#e8e8ff",
                            notInterested: "#ffd4d4",
                            notValid: "#f0f0f0",
                          };

                          // Get color for status (convert to camelCase for matching)
                          const statusKey = item.status
                            .replace(/\s+/g, "")
                            .replace(/^./, (str) => str.toLowerCase());
                          const bgColor = statusColors[statusKey] || "#f5f5f5";

                          return (
                            <li key={index}>
                              <Link
                                to="#"
                                className="bg-success-cus-light"
                                style={{ backgroundColor: bgColor }}
                                title={`Changed on ${dayjs(
                                  item.createdAt
                                ).format("MMM DD, YYYY")}`}
                              >
                                {item.status.charAt(0).toUpperCase() +
                                  item.status.slice(1)}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div className="text-center py-3 text-muted">
                        <span>No status changes yet</span>
                      </div>
                    )}
                  </div> */}
                  <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                    <li className="nav-item" role="presentation">
                      <Link
                        to=""
                        data-bs-toggle="tab"
                        data-bs-target="#notes"
                        className="nav-link active"
                      >
                        <i className="ti ti-notes me-1" />
                        Notes
                      </Link>
                    </li>

                    <li className="nav-item" role="presentation">
                      <Link
                        to=""
                        data-bs-toggle="tab"
                        data-bs-target="#meeting"
                        className="nav-link"
                      >
                        <SlPeople className="me-2" />
                        Meetings
                      </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link
                        to=""
                        data-bs-toggle="tab"
                        data-bs-target="#calls"
                        className="nav-link"
                      >
                        <i className="ti ti-phone me-1" />
                        Calls
                      </Link>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                      <Link
                        to=""
                        data-bs-toggle="tab"
                        data-bs-target="#attachment"
                        className="nav-link"
                      >
                        <IoMdAttach className="me-2" />
                        Attachment
                      </Link>
                    </li> */}
                    <li className="nav-item" role="presentation">
                      <Link
                        to=""
                        data-bs-toggle="tab"
                        data-bs-target="#activities"
                        className="nav-link"
                      >
                        <i className="ti ti-alarm-minus me-1" />
                        Activities
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Tab Content */}
              <div className="tab-content pt-0">
                {/* Activities */}
                <div className="tab-pane fade" id="activities">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Activities</h4>
                      <div className="d-flex " style={{ gap: "1.5rem" }}>
                        <div className="form-sort mt-0">
                          <i className="ti ti-filter" />
                          <Select
                            className="select dropdownCusWidth"
                            options={activityFilterOptions}
                            value={activityFilterOptions.find(
                              (opt) => opt.value === activityFilter
                            )}
                            onChange={(option) =>
                              setActivityFilter(option.value)
                            }
                            placeholder="Filter By Type"
                            classNamePrefix="react-select"
                          />
                        </div>
                        <div className="form-sort mt-0">
                          <i className="ti ti-sort-ascending-2" />
                          <Select
                            className="select dropdownCusWidth"
                            options={ascendingandDecending}
                            value={ascendingandDecending.find(
                              (opt) =>
                                opt.value.toLowerCase() === activitySortOrder
                            )}
                            onChange={(option) =>
                              setActivitySortOrder(option.value.toLowerCase())
                            }
                            placeholder="Sort By Date"
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {activities.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                          <i className="ti ti-timeline fs-1 mb-3 d-block" />
                          <p>No activities yet</p>
                        </div>
                      ) : (
                        <>
                          {getFilteredAndSortedActivities().map(
                            (activity, index) => {
                              const { icon, color } = getActivityIconAndColor(
                                activity.type
                              );
                              const activityDate = new Date(activity.timestamp);
                              const formattedDate =
                                activityDate.toLocaleDateString("en-US", {
                                  day: "numeric",
                                  month: "short",
                                  year: "numeric",
                                });
                              const formattedTime =
                                activityDate.toLocaleTimeString("en-US", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                });

                              // Show date badge for first activity or when date changes
                              const showDateBadge =
                                index === 0 ||
                                new Date(
                                  getFilteredAndSortedActivities()[
                                    index - 1
                                  ].timestamp
                                ).toLocaleDateString() !==
                                activityDate.toLocaleDateString();

                              return (
                                <React.Fragment key={index}>
                                  {showDateBadge && (
                                    <div className="badge badge-soft-purple fs-14 fw-normal shadow-none mb-3">
                                      <i className="ti ti-calendar-check me-1" />
                                      {formattedDate}
                                    </div>
                                  )}
                                  <div className="card border shadow-none mb-3">
                                    <div className="card-body p-3">
                                      <div className="d-flex">
                                        <span
                                          className={`avatar avatar-md flex-shrink-0 rounded me-2 ${color}`}
                                        >
                                          <i className={icon} />
                                        </span>
                                        <div className="flex-grow-1">
                                          <h6 className="fw-medium mb-1">
                                            {activity.title || activity.action}
                                          </h6>
                                          {activity.description && (
                                            <p className="mb-1 text-muted">
                                              {activity.description}
                                            </p>
                                          )}
                                          <p className="mb-0 text-muted small">
                                            {formattedTime}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            }
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Activities */}
                {/* Tasks */}
                <div className="tab-pane active show" id="notes">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold">Notes</h4>
                      <div className="d-inline-flex align-items-center">
                        <div
                          className="form-sort me-3 mt-0"
                          style={{ width: "160px" }}
                        >
                          <i className="ti ti-sort-ascending-2" />
                          <Select
                            className="select dropdownCusWidth"
                            options={ascendingandDecending}
                            value={ascendingandDecending.find(
                              (opt) => opt.value === taskSortOrder
                            )}
                            placeholder="Sort By Date"
                            classNamePrefix="react-select"
                            onChange={(selectedOption) => {
                              dispatch(
                                clearTasksCache(
                                  customerInfo._originalData?.contact_id
                                )
                              );
                              if (selectedOption) {
                                setTaskSortOrder(selectedOption.value);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="notes-activity">
                        {/* Notes Update Section */}

                        {/* Task Form */}
                        <form onSubmit={handleTaskSubmit}>
                          <div className="row">
                            <div className="mb-3 col-md-12">
                              {/* <label className="col-form-label">
                                Contact Notes{" "}
                                <span className="text-danger"> *</span>
                              </label> */}
                              <textarea
                                className="form-control"
                                rows={5}
                                value={taskFormData.taskDescription}
                                onChange={(e) =>
                                  setTaskFormData({
                                    ...taskFormData,
                                    taskDescription: e.target.value,
                                  })
                                }
                                placeholder="Enter note description..."
                              />
                            </div>
                            <div className="mb-3 my-auto col-md-4">
                              {/* Date and Time inputs hidden */}
                            </div>
                          </div>

                          <div className="col-lg-12 d-flex justify-content-end modal-btn mb-4">
                            <button
                              className="btn btn-primary"
                              type="submit"
                              disabled={loadingTasksSubmit}
                            >
                              {loadingTasksSubmit ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  {taskToEdit ? "Updating..." : "Adding..."}
                                </>
                              ) : taskToEdit ? (
                                "Update Note"
                              ) : (
                                "Add Note"
                              )}
                            </button>
                          </div>
                        </form>

                        {/* Tasks List */}
                        {loadingTasksFetch ? (
                          <div className="text-center py-4">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : tasks.length === 0 ? (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 16px", textAlign: "center" }}>
                            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                              <i className="ti ti-notes" style={{ fontSize: 28, color: "#3C2371" }} />
                            </div>
                            <p style={{ fontWeight: 600, color: "#374151", marginBottom: 4, fontSize: 15 }}>No notes yet</p>
                            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 0 }}>Write something in the box above and click Add Note.</p>
                          </div>
                        ) : (
                          tasks.map((task, index) => (
                            <div
                              className="card mb-3"
                              key={task.task_id || index}
                            >
                              <div
                                className="card-body notesBorderLeft"
                                onMouseEnter={() => setHoveredTaskIndex(index)}
                                onMouseLeave={() => setHoveredTaskIndex(null)}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 20,
                                    right: 20,
                                  }}
                                >
                                  {hoveredTaskIndex === index && (
                                    <>
                                      <Link
                                        to=""
                                        className="me-3 styleForEditBtn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#add_tasks"
                                        onClick={() =>
                                          handleTaskEditClick(task)
                                        }
                                      >
                                        <i className="ti ti-edit text-blue" />
                                      </Link>
                                      <Link
                                        to=""
                                        className="styleForDeleteBtn"
                                        data-bs-toggle="modal"
                                        data-bs-target={`#delete_${deleteModalText}`}
                                        onClick={() => {
                                          setDeleteModalText("note");
                                          setTaskToDelete(task);
                                        }}
                                      >
                                        <i className="ti ti-trash text-danger" />
                                      </Link>
                                    </>
                                  )}
                                </div>

                                <div className="mb-3 d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input me-2"
                                    checked={task.taskIsCompleted}
                                    onChange={() =>
                                      handleTaskCompletionToggle(task)
                                    }
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                  {task.taskIsCompleted ? (
                                    <span className="badge badge-soft-success fw-medium">
                                      <MdDownloadDone className="me-1" />
                                      Completed
                                    </span>
                                  ) : (
                                    <span className="badge badge-soft-warning fw-medium">
                                      <FaTasks className="me-1" />
                                      Pending
                                    </span>
                                  )}
                                </div>

                                <p
                                  className="mb-3"
                                  style={{
                                    textDecoration: task.taskIsCompleted
                                      ? "line-through"
                                      : "none",
                                  }}
                                >
                                  {task.taskDescription}
                                </p>

                                {(task.taskDueDate || task.taskDueTime) && (
                                  <div className="mb-2">
                                    <span className="text-muted">
                                      <i className="ti ti-calendar me-1" />
                                      Due:{" "}
                                      {task.taskDueDate &&
                                        new Date(
                                          task.taskDueDate
                                        ).toLocaleDateString()}
                                      {task.taskDueTime &&
                                        ` at ${task.taskDueTime}`}
                                    </span>
                                  </div>
                                )}

                                <div>
                                  <p className="text-muted small mb-0">
                                    <i className="ti ti-clock me-1" />
                                    Created:{" "}
                                    {task.createdAt &&
                                      new Date(task.createdAt).toLocaleString()}
                                    {task.updatedAt &&
                                      task.updatedAt !== task.createdAt && (
                                        <>
                                          {" | "}
                                          Updated:{" "}
                                          {new Date(
                                            task.updatedAt
                                          ).toLocaleString()}
                                        </>
                                      )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Notes */}
                {/* Meeting */}
                <div className="tab-pane fade" id="meeting">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold mb-0">Meeting</h4>
                      <div className="d-inline-flex align-items-center">
                        <div className="form-sort me-3 mt-0">
                          <i className="ti ti-sort-ascending-2" />
                          <Select
                            className="select dropdownCusWidth"
                            options={ascendingandDecending}
                            value={ascendingandDecending.find(
                              (opt) =>
                                opt.value.toLowerCase() === meetingSortOrder
                            )}
                            onChange={(option) => {
                              dispatch(
                                clearMeetingsCache(
                                  customerInfo._originalData?.contact_id
                                )
                              );
                              setMeetingSortOrder(option.value.toLowerCase());
                            }}
                            placeholder="Sort By Date"
                            classNamePrefix="react-select"
                          />
                        </div>
                        <Link
                          to=""
                          data-bs-toggle="modal"
                          data-bs-target="#add_meeting"
                          className="link-purple fw-medium"
                          onClick={() => {
                            setMeetingToEdit(null);
                            setMeetingFormData({
                              meetingTitle: "",
                              meetingDescription: "",
                              meetingStartDate: null,
                              meetingStartTime: "",
                              meetingType: "offline",
                              meetingLocation: "",
                              meetingProvider: null,
                            });
                            setSelectedMeetingType(null);
                          }}
                        >
                          <i className="ti ti-circle-plus me-1" />
                          Add New
                        </Link>
                      </div>
                    </div>
                    <div className="card-body">
                      {loadingMeetings ? (
                        <div className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : meetings.length === 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 16px", textAlign: "center" }}>
                          <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                            <i className="ti ti-calendar-off" style={{ fontSize: 28, color: "#3C2371" }} />
                          </div>
                          <p style={{ fontWeight: 600, color: "#374151", marginBottom: 4, fontSize: 15 }}>No meetings scheduled</p>
                          <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 20 }}>Schedule a meeting with this contact to keep track of your interactions.</p>
                          <Link
                            to=""
                            className="voycell-empty-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#add_meeting"
                            onClick={() => {
                              setMeetingToEdit(null);
                              setMeetingFormData({ meetingTitle: "", meetingDescription: "", meetingStartDate: null, meetingStartTime: "", meetingType: "offline", meetingLocation: "", meetingProvider: null });
                              setSelectedMeetingType(null);
                            }}
                          >
                            <i className="ti ti-calendar-plus" />
                            Schedule a Meeting
                          </Link>
                        </div>
                      ) : (
                        <div className="notes-activity">
                          {meetings.map((meeting, meetingIndex) => {
                            const meetingDate = meeting.meetingStartDate
                              ? new Date(meeting.meetingStartDate)
                              : null;
                            const formattedDate = meetingDate
                              ? meetingDate.toLocaleDateString("en-US", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })
                              : "";
                            const createdDate = meeting.createdAt
                              ? new Date(meeting.createdAt)
                              : null;
                            const formattedCreatedDate = createdDate
                              ? createdDate.toLocaleDateString("en-US", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })
                              : "";

                            return (
                              <div
                                className="card mb-3"
                                key={meeting.meeting_id || meetingIndex}
                              >
                                <div
                                  className="card-body"
                                  onMouseEnter={() =>
                                    setHoveredMeetingIndex(meetingIndex)
                                  }
                                  onMouseLeave={() =>
                                    setHoveredMeetingIndex(null)
                                  }
                                >
                                  <div className="d-flex align-items-center justify-content-between pb-2">
                                    {hoveredMeetingIndex === meetingIndex && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 20,
                                          right: 20,
                                        }}
                                      >
                                        <Link
                                          to=""
                                          className="me-3 styleForEditBtn"
                                          data-bs-toggle="modal"
                                          data-bs-target="#add_meeting"
                                          onClick={() => {
                                            handleMeetingEditClick(meeting);
                                          }}
                                        >
                                          <i className="ti ti-edit text-blue" />
                                        </Link>
                                        <Link
                                          to=""
                                          className="styleForDeleteBtn"
                                          data-bs-toggle="modal"
                                          data-bs-target={`#delete_${deleteModalText}`}
                                          onClick={() => {
                                            setDeleteModalText("meeting");
                                            setMeetingToDelete(meeting);
                                          }}
                                        >
                                          <i className="ti ti-trash text-danger" />
                                        </Link>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-11 mb-3">
                                    {meeting.meetingType === "online" ? (
                                      <p className="badge badge-soft-black fw-medium me-2">
                                        <RiVideoOnLine className="me-2" />
                                        Online
                                      </p>
                                    ) : (
                                      <p className="badge badge-soft-warning fw-medium me-2">
                                        <IoLocationSharp className="me-2" />
                                        Offline
                                      </p>
                                    )}
                                    <p className="fw-medium text-black">
                                      {meeting.meetingTitle ||
                                        "Untitled Meeting"}
                                    </p>
                                    {meeting.meetingDescription && (
                                      <p>{meeting.meetingDescription}</p>
                                    )}
                                    {/* {meeting.meetingType === "online" &&
                                      meeting.meetingLink && (
                                        <p>
                                          <a
                                            href={meeting.meetingLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-primary"
                                          >
                                            Join Meeting
                                          </a>
                                        </p>
                                      )} */}

                                    {meeting.meetingType === "online" && meeting.meetingLink && (
                                      <p className="flex items-center gap-2">
                                        <a
                                          href={meeting.meetingLink}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-primary underline"
                                        >
                                          Join Meeting
                                        </a>

                                        <span
                                          onClick={() => handleCopy(meeting)}
                                          className="cursor-pointer text-gray-400 hover:text-primary transition-transform hover:scale-110 ms-2"
                                          title="Copy link"
                                        >
                                          {copiedId === meeting.id ? (
                                            // <FiCheck size={16} className="text-green-500" />
                                            "Link Copied"
                                          ) : (
                                            <FiCopy size={16} />
                                          )}
                                        </span>
                                      </p>
                                    )}
                                    {meeting.meetingType === "offline" &&
                                      meeting.meetingLocation && (
                                        <p>
                                          <IoLocationSharp className="me-1" />
                                          {meeting.meetingLocation}
                                        </p>
                                      )}
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0">
                                      ✎{" "}
                                      <span className="fw-medium text-black ms-2">
                                        Created on{" "}
                                      </span>{" "}
                                      <span>
                                        {formattedCreatedDate}
                                        {meeting.createdAt &&
                                          ` ${new Date(
                                            meeting.createdAt
                                          ).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}`}
                                      </span>
                                    </p>
                                    <p>
                                      <span className="fw-medium text-black">
                                        Meeting time:
                                      </span>{" "}
                                      {formattedDate} {meeting.meetingStartTime}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Meeting */}
                {/* Attachment */}
                {/* <div className="tab-pane fade" id="attachment">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4 className="fw-semibold mb-0">Attachment</h4>
                    </div>
                    <div className="card-body">
                      <div className="uploadSectionContainer">
                        <div
                          {...getRootProps()}
                          className={`uploadSectionInnerBox ${isDragActive ? "drag-active" : ""}`}
                        >
                          <input {...getInputProps()} />
                          <div className="uploadSectionImageBox">
                            <FcUpload style={{ fontSize: 30 }} />
                          </div>
                          <div className="profile-upload d-block">
                            <div className="profile-upload-content">
                              <label className="profile-upload-btn">
                                <i className="ti ti-file-broken" /> Upload File
                              </label>
                              {isDragActive ? (
                                <p>Drop the files here ...</p>
                              ) : (
                                <p>Drag 'n' drop Excel or CSV files here, or click to select them</p>
                              )}
                            </div>
                          </div>
                          <p className="supportedFormat">
                            (Supported formats .csv, .xlsx; max file size 5 MB)
                          </p>

                        </div>
                      </div>
                      {uploadedFiles.length > 0 && (
                        <div className="uploaded-files">
                          <h4>Uploaded Files:</h4>
                          <ul>
                            {uploadedFiles.map((file, index) => (
                              <li key={index}>{file.name}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}
                {/* /Attachment */}
                {/* Calls */}
                <div className="tab-pane fade" id="calls">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col-sm-12">
                          <div className="container-fluid">
                            {/* Cards Section */}
                            <div className="row g-2 mb-3">
                              {/* Inbound Calls */}
                              <div className="col-12 col-sm-6 col-md-3">
                                <Card
                                  className="metric-card inbound-card"
                                  hoverable
                                  onClick={() => {
                                    setSelectedCallStatus([]);
                                    setSelectedCallDirection(["inbound"]);
                                  }}
                                  styles={{
                                    body: { padding: "0 10px" },
                                  }}
                                >
                                  <Space
                                    direction="horizontal"
                                    size="small"
                                    style={{
                                      width: "100%",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="metric-header">
                                      <IoCall
                                        size={24}
                                        className="metric-icon inbound-icon"
                                      />
                                      <Text
                                        type="secondary"
                                        className="metric-label"
                                      >
                                        Inbound Calls
                                      </Text>
                                    </div>
                                    <Statistic
                                      value={callLogsSummary?.inboundCalls}
                                      precision={0}
                                      className="metric-value"
                                      valueStyle={{
                                        color: "#52c41a",
                                        fontSize: "clamp(16px, 2vw, 24px)",
                                      }}
                                    />
                                  </Space>
                                </Card>
                              </div>

                              {/* Outbound Calls */}
                              <div className="col-12 col-sm-6 col-md-3">
                                <Card
                                  className="metric-card outbound-card"
                                  hoverable
                                  onClick={() => {
                                    setSelectedCallStatus([]);
                                    setSelectedCallDirection(["outbound"]);
                                  }}
                                  styles={{
                                    body: { padding: "0 10px" },
                                  }}
                                >
                                  <Space
                                    direction="horizontal"
                                    size="small"
                                    style={{
                                      width: "100%",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="metric-header">
                                      <IoCallOutline
                                        size={24}
                                        className="metric-icon outbound-icon"
                                      />
                                      <Text
                                        type="secondary"
                                        className="metric-label"
                                      >
                                        Outbound Calls
                                      </Text>
                                    </div>
                                    <Statistic
                                      value={callLogsSummary?.outboundCalls}
                                      precision={0}
                                      className="metric-value"
                                      valueStyle={{
                                        color: "#1890ff",
                                        fontSize: "clamp(16px, 2vw, 24px)",
                                      }}
                                    />
                                  </Space>
                                </Card>
                              </div>

                              {/* Missed Calls */}
                              <div className="col-12 col-sm-6 col-md-3">
                                <Card
                                  className="metric-card outbound-card"
                                  hoverable
                                  onClick={() => {
                                    setSelectedCallDirection([]);
                                    setSelectedCallStatus(["missedCall"]);
                                  }}
                                  styles={{
                                    body: { padding: "0 10px" },
                                  }}
                                >
                                  <Space
                                    direction="horizontal"
                                    size="small"
                                    style={{
                                      width: "100%",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="metric-header">
                                      <IoCallOutline
                                        size={24}
                                        className="metric-icon missed-icon"
                                      />
                                      <Text
                                        type="secondary"
                                        className="metric-label"
                                      >
                                        Missed Calls
                                      </Text>
                                    </div>
                                    <Statistic
                                      value={callLogsSummary?.missedCalls}
                                      precision={0}
                                      className="metric-value"
                                      valueStyle={{
                                        color: "#ff1b1bff",
                                        fontSize: "clamp(16px, 2vw, 24px)",
                                      }}
                                    />
                                  </Space>
                                </Card>
                              </div>

                              {/* Total Calls */}
                              <div className="col-12 col-sm-6 col-md-3">
                                <Card
                                  className="metric-card total-card"
                                  hoverable
                                  onClick={() => {
                                    setSelectedCallDirection([]);
                                    setSelectedCallStatus([]);
                                  }}
                                  styles={{
                                    body: { padding: "0 10px" },
                                  }}
                                >
                                  <Space
                                    direction="horizontal"
                                    size="small"
                                    style={{
                                      width: "100%",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="metric-header">
                                      <IoAlertCircle
                                        size={24}
                                        className="metric-icon total-icon"
                                      />
                                      <Text
                                        type="secondary"
                                        className="metric-label"
                                      >
                                        Total Calls
                                      </Text>
                                    </div>
                                    <Statistic
                                      value={callLogsSummary?.totalCalls}
                                      precision={0}
                                      className="metric-value"
                                      valueStyle={{
                                        color: "#722ed1",
                                        fontSize: "clamp(16px, 2vw, 24px)",
                                      }}
                                    />
                                  </Space>
                                </Card>
                              </div>
                            </div>

                            {/* Filters and Actions Section */}
                            <div className="d-flex justify-content-end flex-wrap gap-2 mb-3">
                              {/* Filter Dropdown */}
                              <div className="form-sorts dropdown me-2 mb-2">
                                <Link
                                  to=""
                                  data-bs-toggle="dropdown"
                                  data-bs-auto-close="outside"
                                >
                                  <i className="ti ti-filter-share" /> Filter
                                </Link>
                                <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                  {/* Filter content goes here as before */}
                                </div>
                              </div>

                              {/* Manage Columns */}
                              <div className="dropdown me-2 mb-2">
                                <Link
                                  to=""
                                  className="btn bg-soft-purple text-purple"
                                  data-bs-toggle="dropdown"
                                  data-bs-auto-close="outside"
                                >
                                  <i className="ti ti-columns-3 me-2" /> Manage
                                  Columns
                                </Link>
                                <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                                  {/* Column management content */}
                                </div>
                              </div>

                              {/* Refresh Button */}
                              <button
                                className="btn btn-primary me-2 mb-2 d-flex align-items-center"
                                onClick={handleRefreshCalls}
                                disabled={isRefreshingCalls}
                                style={{ height: "40px", whiteSpace: "nowrap" }}
                              >
                                <i
                                  className={`ti ti-refresh fs-5 ${isRefreshingCalls ? "ti-spin" : ""
                                    }`}
                                />
                              </button>

                              {/* DateRange Picker */}
                              <div className="icon-form me-2 mb-2">
                                <span className="form-icon">
                                  <i className="ti ti-calendar" />
                                </span>
                                <DateRangePicker
                                  initialSettings={initialSettings}
                                  onCallback={(start, end) => {
                                    const startDate = new Date(
                                      start.year(),
                                      start.month(),
                                      start.date(),
                                      0,
                                      0,
                                      0,
                                      0
                                    ).toISOString();

                                    const endDate = new Date(
                                      end.year(),
                                      end.month(),
                                      end.date(),
                                      23,
                                      59,
                                      59,
                                      999
                                    ).toISOString();
                                    setEndDate(endDate);
                                    setStartDate(startDate);
                                  }}
                                >
                                  <input
                                    className="form-control bookingrange"
                                    type="text"
                                  />
                                </DateRangePicker>
                              </div>

                              {/* Export Dropdown */}
                              <div className="dropdown me-2 mb-2">
                                <Link
                                  to=""
                                  className="dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="ti ti-package-export me-2" />{" "}
                                  Export
                                </Link>
                                <div className="dropdown-menu dropdown-menu-end">
                                  <ul className="mb-0">
                                    <li>
                                      <Link
                                        to=""
                                        className="dropdown-item"
                                        onClick={exportPDF}
                                      >
                                        <i className="ti ti-file-type-pdf text-danger me-1" />{" "}
                                        Export as PDF
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to=""
                                        className="dropdown-item"
                                        onClick={exportExcel}
                                      >
                                        <i className="ti ti-file-type-xls text-green me-1" />{" "}
                                        Export as Excel
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-8">
                          <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"></div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive custom-table">
                        {!callHistoryNumberState.loading && filteredCallData?.length === 0 ? (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 16px", textAlign: "center" }}>
                            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                              <i className="ti ti-phone-off" style={{ fontSize: 28, color: "#3C2371" }} />
                            </div>
                            <p style={{ fontWeight: 600, color: "#374151", marginBottom: 4, fontSize: 15 }}>No calls yet</p>
                            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 20 }}>No call history with this contact. Start a call to connect.</p>
                            <button
                              className="voycell-empty-btn"
                              onClick={() => {
                                if (customerInfo?.phone) {
                                  handlePhoneClick(customerInfo.phone);
                                } else {
                                  dispatch(openDialer());
                                }
                              }}
                            >
                              <i className="ti ti-phone" />
                              Start a Call
                            </button>
                          </div>
                        ) : (
                        <Table
                          dataSource={filteredCallData}
                          columns={visibleColumns}
                          rowKey={(record) => record.key}
                          pagination={{
                            current: callHistoryNumberState.pagination.page,
                            pageSize:
                              callHistoryNumberState.pagination.page_size,
                            total: callHistoryNumberState.pagination.total,
                          }}
                          onPaginationChange={handlePageChange}
                          showRowSelection={false}
                        />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Calls */}
                {/* Quotation */}
                <div className="tab-pane fade" id="quotation">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col-sm-12">
                          <div className="d-flex justify-content-between">
                            Quotation goes here
                          </div>
                        </div>
                        <div className="col-sm-8">
                          <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"></div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body"></div>
                  </div>
                </div>
                {/* /Quotation */}
              </div>
              {/* /Tab Content */}
            </div>
            {/* /Contact Details */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Delete Contact */}
      <Modal show={openModal} onHide={() => setOpenModal(false)} centered>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-theme-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-theme" />
            </div>
            <h4 className="mb-2">Remove Contact?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> contact you selected.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Link
                to=""
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                onClick={() => setOpenModal(false)}
              >
                Cancel
              </Link>
              <Link
                to=""
                onClick={handleDeleteContact}
                className="btn btn-theme text-white"
              >
                Yes, Delete it
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Delete Contact */}
      {/* Create Deal */}
      <div
        className="modal custom-modal fade"
        id="create_success"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-building" />
                </div>
                <h3>Deal Created Successfully!!!</h3>
                <p>View the details of deal, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link
                    to={
                      userProfile.role === "user"
                        ? route.agentContactDetails
                        : route.contactDetails
                    }
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Deal */}
      {/* Add Note */}
      <div
        className="modal custom-modal fade modal-padding"
        id="add_notes"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Notes</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form
                action={
                  userProfile.role === "user"
                    ? route.agentContactDetails
                    : route.contactDetails
                }
              >
                <div className="mb-3">
                  <label className="col-form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Note <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Attachment <span className="text-danger"> *</span>
                  </label>
                  <div className="drag-attach">
                    <input type="file" />
                    <div className="img-upload">
                      <i className="ti ti-file-broken" />
                      Upload File
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="col-form-label">Uploaded Files</label>
                  <div className="upload-file">
                    <h6>Projectneonals teyys.xls</h6>
                    <p>4.25 MB</p>
                    <div className="progress">
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: "25%" }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                    <p className="black-text">45%</p>
                  </div>
                  <div className="upload-file upload-list">
                    <div>
                      <h6>tes.txt</h6>
                      <p>4.25 MB</p>
                    </div>
                    <Link to="" className="text-danger">
                      <i className="ti ti-trash-x" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-12 text-end modal-btn">
                  <Link to="" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button className="btn btn-primary" type="submit">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Note */}
      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form
                action={
                  userProfile.role === "user"
                    ? route.agentContactDetails
                    : route.contactDetails
                }
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        defaultValue={""}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" /> Create a followup note
                      </label>
                    </div>
                    <div className="text-end modal-btn">
                      <Link
                        to=""
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" type="submit">
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Call Log */}
      {/* Add File */}
      <div
        className="modal custom-modal fade custom-modal-two modal-padding"
        id="new_file"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New File</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-info-fieldset">
                <div className="add-details-wizard">
                  <ul className="progress-bar-wizard">
                    <li className="active">
                      <span>
                        <i className="ti ti-file" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Basic Info</h6>
                      </div>
                    </li>
                    <li>
                      <span>
                        <i className="ti ti-circle-plus" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Add Recipient</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <fieldset id="first-field-file">
                  <form
                    action={
                      userProfile.role === "user"
                        ? route.agentContactDetails
                        : route.contactDetails
                    }
                  >
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Choose Deal <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={dealsopen}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Document Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={documentType}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Owner <span className="text-danger">*</span>
                            </label>
                            <SelectWithImage2 />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Title <span className="text-danger"> *</span>
                            </label>
                            <input className="form-control" type="text" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Locale <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={LocaleData}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4>Signature</h4>
                            <ul className="nav sign-item">
                              <li className="nav-item">
                                <span
                                  className=" mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nosign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign1"
                                    name="email"
                                  />
                                  <label htmlFor="sign1">
                                    <span className="sign-title">
                                      No Signature
                                    </span>
                                    This document does not require a signature
                                    before acceptance.
                                  </label>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span
                                  className="active mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#use-esign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign2"
                                    name="email"
                                    defaultChecked
                                  />
                                  <label htmlFor="sign2">
                                    <span className="sign-title">
                                      Use e-signature
                                    </span>
                                    This document require e-signature before
                                    acceptance.
                                  </label>
                                </span>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className="tab-pane show active"
                                id="use-esign"
                              >
                                <div className="input-block mb-0">
                                  <label className="col-form-label">
                                    Document Signers{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="sign-content">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-3">
                                        <input
                                          className="form-control"
                                          type="text"
                                          placeholder="Enter Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="float-none mb-3 me-3 w-100">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email Address"
                                          />
                                        </div>
                                        <div className="input-btn mb-3">
                                          <Link to="" className="add-sign">
                                            <i className="ti ti-circle-plus" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Content <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Add Content"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Reset
                          </button>
                          <button
                            className="btn btn-primary wizard-next-btn"
                            type="button"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
                <fieldset>
                  <form
                    action={
                      userProfile.role === "user"
                        ? route.agentContactDetails
                        : route.contactDetails
                    }
                  >
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4 className="mb-2">
                              Send the document to following signers
                            </h4>
                            <p>In order to send the document to the signers</p>
                            <div className="input-block mb-0">
                              <label className="col-form-label">
                                Recipients (Additional recipients)
                              </label>
                            </div>
                            <div className="sign-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="d-flex align-items-center">
                                    <div className="float-none mb-3 me-3 w-100">
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email Address"
                                      />
                                    </div>
                                    <div className="input-btn mb-3">
                                      <Link to="" className="add-sign">
                                        <i className="ti ti-circle-plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Subject{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter Subject"
                            />
                          </div>
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Text{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Your document is ready"
                              defaultValue={""}
                            />
                          </div>
                          <button className="btn btn-light mb-3">
                            Send Now
                          </button>
                          <div className="send-success">
                            <p>
                              <i className="ti ti-circle-check" /> Document sent
                              successfully to the selected recipients
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            data-bs-dismiss="modal"
                          >
                            Save &amp; Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add File */}
      {/* Connect Account */}
      <div className="modal custom-modal fade" id="create_email" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Connect Account</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="col-form-label">
                  Account type <span className="text-danger"> *</span>
                </label>
                <Select
                  className="select2"
                  options={accountType}
                  placeholder="Choose"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="mb-3">
                <h5 className="form-title">Sync emails from</h5>
                <div className="sync-radio">
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test1"
                      name="radio-group"
                      defaultChecked
                    />
                    <label htmlFor="test1">Now</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test2"
                      name="radio-group"
                    />
                    <label htmlFor="test2">1 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test3"
                      name="radio-group"
                    />
                    <label htmlFor="test3">3 Month Ago</label>
                  </div>
                  <div className="radio-item">
                    <input
                      type="radio"
                      className="status-radio"
                      id="test4"
                      name="radio-group"
                    />
                    <label htmlFor="test4">6 Month Ago</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 text-end modal-btn">
                <Link to="" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button
                  className="btn btn-primary"
                  data-bs-target="#success_mail"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                >
                  Connect Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Connect Account */}
      {/* Success Contact */}
      <div className="modal custom-modal fade" id="success_mail" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-mail-opened" />
                </div>
                <h3>Email Connected Successfully!!!</h3>
                <p>
                  Email Account is configured with “example@example.com”. Now
                  you can access email.
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link
                    to={
                      userProfile.role === "user"
                        ? route.agentContactDetails
                        : route.contactDetails
                    }
                    className="btn btn-primary"
                  >
                    Go to email
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Success Contact */}
      {/* Access */}
      <div className="modal custom-modal fade" id="access_view" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Access For</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form
                action={
                  userProfile.role === "user"
                    ? route.agentContactDetails
                    : route.contactDetails
                }
              >
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-19.jpg"
                            alt=""
                          />
                          <Link to="">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-20.jpg"
                            alt=""
                          />
                          <Link to="">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt=""
                          />
                          <Link to="">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt=""
                          />
                          <Link to="">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-16.jpg"
                            alt=""
                          />
                          <Link to="">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-22.jpg"
                            alt=""
                          />
                          <Link to="">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link to="" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="submit" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Access */}
      {/* Add Compose */}
      <div className="modal custom-modal fade" id="add_compose" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Compose</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form action="">
                <div className="mb-3">
                  <input
                    type="email"
                    placeholder="To"
                    className="form-control"
                  />
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <input
                        type="email"
                        placeholder="Cc"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <input
                        type="email"
                        placeholder="Bcc"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="Subject"
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <DefaultEditor className="summernote" />
                </div>
                <div className="mb-3">
                  <div className="text-center">
                    <button className="btn btn-primary">
                      <span>Send</span>
                      <i className="fa-solid fa-paper-plane ms-1" />
                    </button>
                    <button className="btn btn-primary ms-1" type="button">
                      <span>Draft</span>{" "}
                      <i className="fa-regular fa-floppy-disk ms-1" />
                    </button>
                    <button className="btn btn-primary ms-1" type="button">
                      <span>Delete</span>{" "}
                      <i className="fa-regular fa-trash-can ms-1" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Compose */}
      {/* Add or Edit Contact */}
      <CustomerOffcanvas
        selectedCustomer={selectedCustomer}
        onContactUpdated={handleOffcanvasClose}
      />
      {/* /Add or Edit Contact */}
      {/* Add New Deals */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add_2"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Deals</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Deal Name <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <label className="col-form-label">
                      Pipeine <span className="text-danger">*</span>
                    </label>
                  </div>
                  <Select
                    className="select2"
                    options={salestypelist}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={status}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Deal Value<span className="text-danger"> *</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Currency <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={optionssymbol}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Period <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={duration}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Period Value <span className="text-danger">*</span>
                  </label>
                  <input className="form-control" type="text" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Contact <span className="text-danger">*</span>
                  </label>
                  <SelectWithImage2 />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Project <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={project}
                    defaultValue={tagInputValues}
                    isMulti
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Due Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Expected Closing Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>

                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate1}
                      onChange={handleDateChange1}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Assignee <span className="text-danger">*</span>
                  </label>
                  <SelectWithImage2 />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Follow Up Date <span className="text-danger">*</span>
                  </label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Source <span className="text-danger">*</span>
                  </label>

                  <Select
                    className="select2"
                    options={socialMedia}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Tags <span className="text-danger">*</span>
                  </label>
                  <TagsInput
                    // className="input-tags form-control"
                    value={owner}
                    onChange={setOwner}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="col-form-label">
                    Priority <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    options={priorityList}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <DefaultEditor className="summernote" />
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setOpenModal(true)}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Deals */}
      {/* Add Company */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Company</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to=""
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="profile-upload">
                            <div className="profile-upload-img">
                              <span>
                                <i className="ti ti-photo" />
                              </span>
                              <ImageWithBasePath
                                src="assets/img/profiles/avatar-20.jpg"
                                alt="img"
                                className="preview1"
                              />
                              <button type="button" className="profile-remove">
                                <i className="ti ti-x" />
                              </button>
                            </div>
                            <div className="profile-upload-content">
                              <label className="profile-upload-btn">
                                <i className="ti ti-file-broken" /> Upload File
                                <input type="file" className="input-img" />
                              </label>
                              <p>JPG, GIF or PNG. Max size of 800K</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Company Name</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <label className="col-form-label">
                              Email <span className="text-danger">*</span>
                            </label>
                            <div className="status-toggle small-toggle-btn d-flex align-items-center">
                              <span className="me-2 label-text">
                                Email Opt Out
                              </span>
                              <input
                                type="checkbox"
                                id="user"
                                className="check"
                                defaultChecked
                              />
                              <label htmlFor="user" className="checktoggle" />
                            </div>
                          </div>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone 1 <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Phone 2</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Fax <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Website <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Ratings</label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="4.2"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="fmb-3">
                          <label className="col-form-label">Owner</label>
                          <SelectWithImage2 />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Tags </label>
                          <input
                            className="input-tags form-control"
                            type="text"
                            data-role="tagsinput"
                            name="Label"
                            defaultValue="Collab"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="col-form-label">Deals</label>
                            <Link
                              to=""
                              className="label-add"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvas_add_2"
                            >
                              <i className="ti ti-square-rounded-plus" />
                              Add New
                            </Link>
                          </div>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={dealsopen}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Source <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={activities}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Industry <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={industries}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Contacts</label>
                          <Select
                            className="select2"
                            options={project}
                            defaultValue={tagInputValues}
                            isMulti
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Currency <span className="text-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Language <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={languages}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0">
                          <label className="col-form-label">
                            Description <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={5}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to=""
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="address"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Street Address{" "}
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">City </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            State / Province{" "}
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Country</label>
                          <Select
                            className="select2"
                            classNamePrefix="react-select"
                            options={countries}
                            placeholder="Choose"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Zipcode </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}
              {/* Social Profile */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to=""
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
              {/* Access */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to=""
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#access-info"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-accessible fs-20" />
                    </span>
                    Access
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="access-info"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Visibility</label>
                          <div className="d-flex flex-wrap">
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="public"
                                name="visible"
                              />
                              <label htmlFor="public">Public</label>
                            </div>
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="private"
                                name="visible"
                              />
                              <label htmlFor="private">Private</label>
                            </div>
                            <div
                              data-bs-toggle="modal"
                              data-bs-target="#access_view"
                            >
                              <input
                                type="radio"
                                className="status-radio"
                                id="people"
                                name="visible"
                              />
                              <label htmlFor="people">Select People</label>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0">
                          <label className="col-form-label">Status</label>
                          <div className="d-flex flex-wrap">
                            <div className="me-2">
                              <input
                                type="radio"
                                className="status-radio"
                                id="active"
                                name="status"
                                defaultChecked
                              />
                              <label htmlFor="active">Active</label>
                            </div>
                            <div>
                              <input
                                type="radio"
                                className="status-radio"
                                id="inactive"
                                name="status"
                              />
                              <label htmlFor="inactive">Inactive</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Access */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#create_success"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* Add Company */}

      {/* Add Edit Task */}
      <div
        className="modal custom-modal fade modal-padding"
        id="add_tasks"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {taskToEdit ? "Edit Note" : "Add new Note"}
              </h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setTaskToEdit(null);
                  setTaskFormData({
                    taskDescription: "",
                    taskDueDate: null,
                    taskDueTime: "",
                  });
                  setContactedToday(false);
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleTaskSubmit(e);
                  // Close modal on success
                  const closeBtn = document.querySelector(
                    '#add_tasks [data-bs-dismiss="modal"]'
                  );
                  if (closeBtn) closeBtn.click();
                }}
              >
                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    name="taskDescription"
                    value={taskFormData.taskDescription}
                    onChange={(e) =>
                      setTaskFormData({
                        ...taskFormData,
                        taskDescription: e.target.value,
                      })
                    }
                    placeholder="Enter note description..."
                  />
                </div>

                <div
                  className="mb-3"
                  style={{ height: "0px", overflow: "hidden" }}
                >
                  <label className="col-form-label">Due Date</label>
                  <div className="icon-form-end">
                    <span className="form-icon">
                      <i className="ti ti-calendar-event" />
                    </span>
                    <DatePicker
                      key={taskToEdit ? `edit-${taskToEdit.task_id}` : "new"}
                      className="form-control datetimepicker deals-details"
                      value={taskFormData.taskDueDate}
                      onChange={(date) => {
                        setTaskFormData({
                          ...taskFormData,
                          taskDueDate: date,
                        });
                      }}
                      format="DD-MM-YYYY"
                      placeholder="Select due date"
                    />
                  </div>
                </div>

                <div
                  className="mb-3"
                  style={{ height: "0px", overflow: "hidden" }}
                >
                  <label className="col-form-label">Due Time</label>
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-clock-hour-10" />
                    </span>
                    <TimePicker
                      placeholder="Select Time"
                      className="form-control datetimepicker-time"
                      onChange={(time, timeString) =>
                        setTaskFormData({
                          ...taskFormData,
                          taskDueTime: timeString,
                        })
                      }
                      value={
                        taskFormData.taskDueTime
                          ? dayjs(taskFormData.taskDueTime, "HH:mm:ss")
                          : null
                      }
                      defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                    />
                  </div>
                </div>

                <div className="col-lg-12 text-end modal-btn">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setTaskToEdit(null);
                      setTaskFormData({
                        taskDescription: "",
                        taskDueDate: null,
                        taskDueTime: "",
                      });
                      setContactedToday(false);
                    }}
                  >
                    Cancel
                  </Link>
                  <button className="btn btn-primary" type="submit">
                    {taskToEdit ? "Update Note" : "Add Note"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Edit Task */}
      {/* Add Edit Meeting */}
      <div
        className="modal custom-modal fade modal-padding"
        id="add_meeting"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {meetingToEdit ? "Edit Meeting" : "Add new Meeting"}
              </h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setMeetingToEdit(null);
                  setMeetingFormData({
                    meetingTitle: "",
                    meetingDescription: "",
                    meetingStartDate: null,
                    meetingStartTime: "",
                    meetingType: "offline",
                    meetingLocation: "",
                    meetingProvider: null,
                  });
                  setSelectedMeetingType(null);
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleMeetingSubmit}>
                <div className="mb-3">
                  <label className="col-form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={meetingFormData.meetingTitle}
                    onChange={(e) =>
                      setMeetingFormData({
                        ...meetingFormData,
                        meetingTitle: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="col-form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={meetingFormData.meetingDescription}
                    onChange={(e) =>
                      setMeetingFormData({
                        ...meetingFormData,
                        meetingDescription: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="row">
                  {/* <div className="col-md-6 mb-3">
                    <label className="col-form-label">
                      Start Date <span className="text-danger"> *</span>
                    </label>
                    <div className="icon-form-end">
                      <span className="form-icon">
                        <i className="ti ti-calendar-event" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker deals-details"
                        format="DD-MM-YYYY"
                        value={meetingFormData.meetingStartDate}
                        onChange={(date) =>
                          setMeetingFormData({
                            ...meetingFormData,
                            meetingStartDate: date,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">Start Time</label>
                    <div className="icon-form">
                      <span className="form-icon">
                        <i className="ti ti-clock-hour-10" />
                      </span>
                      <TimePicker
                        placeholder="Select Time"
                        className="form-control datetimepicker-time"
                        value={
                          meetingFormData.meetingStartTime
                            ? dayjs(meetingFormData.meetingStartTime, "HH:mm")
                            : null
                        }
                        onChange={(time, timeString) =>
                          setMeetingFormData({
                            ...meetingFormData,
                            meetingStartTime: timeString,
                          })
                        }
                        format="HH:mm"
                      />
                    </div>
                  </div> */}


                  <div className="col-md-12 mb-3">
                    <label className="col-form-label">
                      Start Date & Time <span className="text-danger"> *</span>
                    </label>



                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      format="DD-MM-YYYY hh:mm A"
                      showTime={{
                        use12Hours: true,
                        format: "hh:mm A",
                      }}
                      value={meetingFormData.meetingStartDate || null}
                      disabledDate={(current) => {
                        // Disable all dates before today
                        return current && current < dayjs().startOf("day");
                      }}
                      disabledTime={(current) => {
                        if (!current) return {};

                        const now = dayjs();

                        // Only restrict time if the selected date is today
                        if (current.isSame(now, "day")) {
                          const currentHour = now.hour();
                          const currentMinute = now.minute();

                          return {
                            // Disable all past hours
                            disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
                            // Disable past minutes only in the current hour
                            disabledMinutes: (selectedHour) =>
                              selectedHour === currentHour
                                ? Array.from({ length: currentMinute }, (_, i) => i)
                                : [],
                            disabledSeconds: () => [], // allow any seconds
                          };
                        }

                        // No restrictions for future dates
                        return {
                          disabledHours: () => [],
                          disabledMinutes: () => [],
                          disabledSeconds: () => [],
                        };
                      }}
                      onChange={(date) => {
                        if (!date) {
                          setMeetingFormData({
                            ...meetingFormData,
                            meetingStartDate: null,
                            meetingStartTime: null,
                          });
                          return;
                        }

                        setMeetingFormData({
                          ...meetingFormData,
                          // ✅ dayjs object (required for .toISOString())
                          meetingStartDate: date,

                          // ✅ AM/PM time string
                          meetingStartTime: date.format("hh:mm A"),
                        });
                      }}
                    />
                    {/* </div> */}
                  </div>

                </div>

                <div className="mb-3">
                  <label className="col-form-label">Meeting Type</label>
                  <Select
                    className="select2"
                    options={meetingType}
                    value={
                      meetingFormData.meetingType
                        ? meetingType.find(
                          (option) =>
                            option.value.toLowerCase() ===
                            meetingFormData.meetingType
                        )
                        : null
                    }
                    onChange={(option) => {
                      setMeetingFormData({
                        ...meetingFormData,
                        meetingType: option.value.toLowerCase(),
                        meetingLocation:
                          option.value.toLowerCase() === "online"
                            ? ""
                            : meetingFormData.meetingLocation,
                        meetingProvider:
                          option.value.toLowerCase() === "offline"
                            ? null
                            : meetingFormData.meetingProvider,
                      });
                      setSelectedMeetingType(option.value);
                    }}
                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />
                </div>

                {meetingFormData.meetingType === "online" && (
                  <div className="mb-3">
                    <label className="col-form-label">
                      Meeting Provider <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="select2"
                      options={[
                        { value: "google", label: "Google Meet" },
                        { value: "zoom", label: "Zoom" },
                      ]}
                      value={
                        meetingFormData.meetingProvider
                          ? [
                            { value: "google", label: "Google Meet" },
                            { value: "zoom", label: "Zoom" },
                          ].find(
                            (option) =>
                              option.value === meetingFormData.meetingProvider
                          )
                          : null
                      }
                      onChange={(option) => {
                        setMeetingFormData({
                          ...meetingFormData,
                          meetingProvider: option.value,
                        });
                      }}
                      placeholder="Select Provider"
                      classNamePrefix="react-select"
                    />
                    <div className="alert alert-info d-flex align-items-center mt-2">
                      <i className="ti ti-info-circle me-2"></i>
                      <span>
                        {meetingFormData.meetingProvider === "zoom"
                          ? "A Zoom meeting link will be automatically generated when you save this meeting."
                          : meetingFormData.meetingProvider === "google"
                            ? "A Google Meet link will be automatically generated when you save this meeting."
                            : "Select a provider to create an online meeting link automatically."}
                      </span>
                    </div>
                  </div>
                )}

                {meetingFormData.meetingType === "offline" && (
                  <div className="mb-3">
                    <label className="col-form-label">Location</label>
                    <input
                      className="form-control"
                      type="text"
                      value={meetingFormData.meetingLocation}
                      onChange={(e) =>
                        setMeetingFormData({
                          ...meetingFormData,
                          meetingLocation: e.target.value,
                        })
                      }
                    />
                  </div>
                )}

                <div className="col-lg-12 text-end modal-btn mt-4">
                  <button
                    type="button"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setMeetingToEdit(null);
                      setMeetingFormData({
                        meetingTitle: "",
                        meetingDescription: "",
                        meetingStartDate: null,
                        meetingStartTime: "",
                        meetingType: "offline",
                        meetingLocation: "",
                        meetingProvider: null,
                      });
                      setSelectedMeetingType(null);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    // data-bs-dismiss="modal"
                    disabled={isMeetingLoading}
                  >
                    {isMeetingLoading && <Spin indicator={<LoadingOutlined spin style={{ color: "white", marginRight: 5 }} />} size="small" />} {meetingToEdit ? "Update Meeting" : "Add Meeting"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Edit Meeting */}

      {
        <DeleteModal
          text={deleteModalText}
          onDelete={() => {
            handleModalDeleteBtn(deleteModalText);
          }}
          onCancel={() => {
            setDeleteModalText("");
          }}
        />
      }
      {/* /Delete Meeting */}
      <div
        className="modal custom-modal fade modal-padding"
        id="play_recording"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Recording</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => { }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="px-4">
                {audioUrl && (
                  <audio
                    controls
                    id="globalAudioPlayer"
                    src={audioUrl}
                    style={{ width: "100%", marginTop: "20px" }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmailTemplateModal
        fetchActivities={fetchActivities}
        category={"contact"}
      />
      {/* <WhatsappTemplateModal
        fetchActivities={fetchActivities}
        category={"contact"}
      /> */}
      <WhatsappTemplateModal from={customerInfo?.allPhones[0]} />

    </>
  );
};

export default ContactDetails;
